<template>
  <ValidationObserver ref="editForm" v-slot="{ invalid }">
    <div :class="`${isLanding ? 'form-landing' : 'p-2'}`">
      <vx-card :class="!showPanel ? 'painel-no-border' : 'painel-border'">
        <div
          class="text-center mb-5"
          v-if="
            hideLogo != true && logo != '' && isInterno === false && !isLanding
          "
        >
          <img
            :src="logo"
            width="70%"
            style="display: inline; max-width: 250px"
          />
        </div>
        <div class="vx-row">
          <vs-col
            v-if="quotation"
            class="flex w-auto justify-start items-center mb-3"
          >
            <h2>
              {{ getProposalNumberLabel() }}
            </h2>
          </vs-col>
          <vs-col
            class="flex w-auto flex-grow justify-end items-center mb-3 gap-2"
          >
            <vs-button
              v-if="hasPdf"
              @click="openPdf()"
              color="success"
              type="gradient"
              icon-pack="feather"
              icon="icon-file-text"
              class="rounded-full"
              v-tooltip="getLabelContrato()"
              data-testId="open-pdf-button"
            />

            <vs-button
              v-if="
                quotation &&
                permissaoRecusaCorretora &&
                mostrarBotaoRecusa() &&
                !isProposalRefused
              "
              @click="recusarCorretora(quotation.id)"
              color="danger"
              type="gradient"
              icon-pack="feather"
              icon="icon-x"
              class="rounded-full"
              v-tooltip="'Recusar'"
              data-testId="refuse-quotation-button"
            />

            <vs-button
              v-if="canShowModalLogs"
              @click="openModalLogs()"
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-list"
              class="rounded-full"
              v-tooltip="'Histórico de Alterações'"
              data-testId="quotation-logs-modal-button"
            />

            <vs-button
              icon-pack="feather"
              icon="icon-mail"
              class="rounded-full purple-gradient-btn"
              @click="openModalHistoricoMensageria()"
              v-tooltip="'Histórico de Mensageria'"
              data-testId="quotation-message-modal-button"
            />
          </vs-col>
        </div>
        <p v-if="isPolicy">
          <span class="font-bold">Nº da apólice:</span>
          {{
            formatStarNumber(
              quotation.policyNumber,
              TIPO_APOLICES.AUTO,
              'POLICY',
            )
          }}
        </p>
        <p v-if="quotation && quotation.cnsegCi">
          <span class="font-bold">CI:</span> {{ quotation.cnsegCi }}
        </p>
        <p v-if="isProposal">
          <span class="font-bold">Nº da proposta:</span>
          {{
            formatStarNumber(
              quotation.proposal_number,
              TIPO_APOLICES.AUTO,
              'PROPOSAL',
            )
          }}
        </p>
        <p v-if="quotation && quotation.proposal_id">
          <span class="font-bold">Nº da cotação:</span>
          {{ quotation.proposal_id }}
        </p>
        <p v-if="quotation && quotation.created_at">
          <span class="font-bold">Data da cotação:</span> {{ getCreatedAt }}
        </p>
        <p v-if="quotation && quotation.proposal_date">
          <span class="font-bold">Data da proposta:</span>
          {{ getProposalDate }}
        </p>
        <p v-if="quotation && quotation.broker">
          <span class="font-bold">Corretora:</span>
          {{ quotation.broker.name }}
        </p>
        <p v-if="quotation && quotation.consultancy">
          <span class="font-bold">Assessoria:</span>
          {{ quotation.consultancy.name }}
        </p>
        <div class="form-part-title mt-6 mb-6">
          <span>Dados da Proposta</span>
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-1/4 w-full mb-2">
            <label for="Início Vigência" class="vs-select--label"
              >Início Vigência</label
            >
            <ValidationProvider name="Início Vigência" rules="required">
              <flat-pickr
                class="input-data-ativacao"
                id="Início Vigência"
                v-model="fieldsWithValidation.startOfValidity"
                :config="{
                  ...getConfigDateTimePickerDay(),
                  maxDate: dataFutura30Dias,
                }"
                placeholder="DD/MM/AAAA"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="start-of-validity"
              />
            </ValidationProvider>
            <span
              v-show="requiredStartVigencyDate.invalid"
              class="text-danger"
              data-testId="start-of-validity-error"
              >{{ requiredStartVigencyDate.message }}</span
            >
          </div>

          <div class="vx-col sm:w-1/4 w-full mb-2">
            <label for="Fim Vigência" class="vs-select--label"
              >Fim Vigência</label
            >
            <ValidationProvider name="Fim Vigência" rules="required">
              <flat-pickr
                class="input-data-ativacao"
                id="Fim Vigência"
                v-model="fieldsWithValidation.endOfValidity"
                :config="{
                  ...getConfigDateTimePickerDay(),
                  minDate: minDateFimVigencia,
                }"
                placeholder="DD/MM/AAAA"
                data-testId="end-of-validity"
                disabled
              />
            </ValidationProvider>

            <span
              v-show="requiredEndVigencyDate.invalid"
              class="text-danger"
              data-testId="end-of-validity-error"
              >{{ requiredEndVigencyDate.message }}</span
            >
          </div>
        </div>

        <div class="form-part-title mt-6 mb-6">
          <span>Renovação e Bônus</span>
        </div>

        <div class="vx-row mb-2">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <label for="Bonus" class="vs-select--label">É uma renovação?</label>
            <ValidationProvider
              name="É uma renovação?"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                :options="insuranceCompanies"
                id="É uma renovação?"
                v-model="fieldsWithValidation.insuranceCompanyCode"
                :reduce="(item) => item.id"
                :danger="!!errors.length"
                disabled
                :filter="filterOptions"
                data-testId="is-renewal-checkbox"
                ><template #selected-option="option">
                  {{ getSelectedCongenerLabel(option) }}
                </template>
              </v-select>
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="is-renewal-checkbox-error"
                >{{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>

          <div v-if="isRenovationByCNSeg" class="vx-col sm:w-1/4 w-full mb-2">
            <label for="Bonus" class="vs-select--label">Nível de Bônus</label>
            <ValidationProvider
              name="Nível de Bônus"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                :options="bonusesLevel"
                id="Nível de Bônus"
                v-model="fieldsWithValidation.bonus"
                :reduce="(item) => item.id"
                :danger="!!errors.length"
                data-testId="bonus-level"
                disabled
              ></v-select>
              <span v-show="!!errors.length" class="text-danger">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>

          <div v-if="isRenovationByCNSeg" class="vx-col sm:w-1/4 w-full mb-2">
            <ValidationProvider
              name="CI"
              rules="required|min:14|max:14|validate_ci"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                label="CI Anterior"
                v-model="fieldsWithValidation.ci"
                id="CI"
                v-mask="'##############'"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="ci"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="ci-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>

          <div v-if="isRenovationByCNSeg" class="vx-col sm:w-1/4 w-full mb-2">
            <ValidationProvider
              name="N° da apólice anterior"
              rules="required|max:16"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                label="N° da apólice anterior"
                id="N° da apólice anterior"
                type="number"
                v-mask="'################'"
                v-model="fieldsWithValidation.policyNumber"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="previous-policy-number"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="previous-policy-number-error"
                >{{ errors[0] }}</span
              >
            </ValidationProvider>
          </div>
          <div v-if="isRenovationByCNSeg" class="vx-col sm:w-1/4 w-full mb-2">
            <label for="Fim da vigência anterior" class="vs-select--label"
              >Fim da vigência anterior</label
            >
            <ValidationProvider
              name="Fim da vigência anterior"
              rules="required"
            >
              <flat-pickr
                class="input-data-ativacao"
                id="Fim da vigência anterior"
                v-model="fieldsWithValidation.previousCoverageEndDate"
                :config="{
                  ...getConfigDateTimePickerDay(),
                  minDate: dataFutura30Dias,
                  minDate: null,
                }"
                placeholder="DD/MM/AAAA"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="previous-coverage-end-date"
              />
              <span
                v-show="requiredPreviousEndVigencyDate.invalid"
                class="text-danger"
                >{{ requiredPreviousEndVigencyDate.message }}</span
              >
            </ValidationProvider>
          </div>
          <div v-if="isRenovationByCNSeg" class="vx-col sm:w-1/5 w-full">
            <label for="Bonus" class="vs-select--label">
              Veículo Igual ao Anterior
            </label>
            <ValidationProvider
              name="Veículo Igual ao Anterior"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                :options="isSameVehicleOptions"
                id="Veículo Igual ao Anterior"
                v-model="fieldsWithValidation.isSameVehicle"
                :reduce="(item) => item.value"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled ||
                  isBrandNew ||
                  !canEditAndTransmit
                "
                data-testId="is-same-vehicle-select"
              ></v-select>
              <span v-show="!!errors.length" class="text-danger"
                >{{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div v-if="isRenovationByCNSeg" class="vx-col sm:w-1/4 w-full mb-2">
            <vs-input
              v-if="!brokerAccountConfigs.cnseg_enabled"
              class="w-full"
              id="Documento da apólice"
              name="Documento da apólice"
              label="Documento da apólice Anterior"
              type="file"
              hidden
              @change="uploadDocument('apolice-bonus', $event)"
            />
            <vs-button
              v-if="!brokerAccountConfigs.cnseg_enabled"
              color="warning"
              type="border"
              class="mr-3 mt-2 text-center"
              @click.prevent="chooseFiles('Documento da apólice')"
              :disabled="isAlreadyTransmittedOrCanceled || !canEditAndTransmit"
              data-testId="policy-document"
            >
              Escolher um Documento
              <feather-icon icon="UploadIcon" class="ml-2" />
            </vs-button>
            <a v-if="policyDocumentBonus" :href="policyDocumentBonus" download>
              Download
            </a>
            <span
              v-show="requiredPolicyDocumentBonus.invalid"
              class="text-danger"
            >
              <br />
              {{ requiredPolicyDocumentBonus.message }}
            </span>
          </div>
        </div>

        <div class="form-part-title mt-6 mb-6">
          <span>Dados do Segurado</span>
        </div>

        <div class="vx-row mb-4 w-full">
          <div class="vx-col w-full sm:w-3/12">
            <ValidationProvider
              name="CPF-CNPJ"
              rules="required|cpf_cnpj_min|cpf_cnpj"
              v-slot="{ errors }"
            >
              <vs-input
                v-model="fieldsWithValidation.cpfcnpj"
                class="w-full"
                label="CPF-CNPJ"
                id="cpfCnpjInput"
                v-mask="[DOCUMENT_MASK.CPF, DOCUMENT_MASK.CNPJ]"
                :danger="!!errors.length"
                disabled
                data-testId="insured-cpf-cnpj"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-cpf-cnpj-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>

          <div v-if="!isPerson" class="vx-col w-full sm:w-6/12">
            <ValidationProvider
              name="Nome"
              rules="required|nome"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                :label="'Razão Social'"
                v-model="fieldsWithValidation.name"
                id="Nome"
                :danger="!!errors.length"
                disabled
                data-testId="insured-business-name"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-business-name-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>

          <div
            v-if="!isPerson && fieldsWithValidation.ie"
            class="vx-col w-full sm:w-3/12"
          >
            <ValidationProvider
              name="Inscrição Estadual"
              rules="required|max:14"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                label="Inscrição Estadual"
                v-model="fieldsWithValidation.ie"
                v-mask="'##############'"
                id="Inscrição Estadual"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="state-registration"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="state-registration-error"
              >
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-4">
          <div v-if="isPerson" class="vx-col w-full sm:w-5/12">
            <ValidationProvider
              name="Nome"
              rules="required|is-person-name"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                :label="'Nome Completo / Nome Social'"
                v-model="fieldsWithValidation.name"
                id="Nome"
                :danger="!!errors.length"
                disabled
                data-testId="insured-full-name"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-full-name-error"
                >{{ errors[0] }}</span
              >
            </ValidationProvider>
          </div>

          <div
            v-if="isPerson"
            class="vx-col w-full sm:w-2/12 checkBoxNomeSocial"
          >
            <vs-checkbox
              v-model="socialName"
              disabled
              data-testId="insured-social-name-checkbox"
            >
              Nome Social?
            </vs-checkbox>
          </div>

          <div v-if="socialName" class="vx-col w-full sm:w-5/12">
            <ValidationProvider
              name="Nome Civil"
              rules="required|is-person-name"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                label="Nome Civil"
                v-model="fieldsWithValidation.civilName"
                id="Nome Civil"
                :danger="!!errors.length"
                disabled
                data-testId="insured-civil-name"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-civil-name-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>
        </div>

        <div class="vx-row mb-4">
          <div v-if="isPerson" class="vx-col sm:w-1/6 w-full">
            <ValidationProvider
              name="Data de Nascimento Segurado"
              :rules="{
                required: true,
                date_format: 'dd/MM/yyyy',
                min_age: true,
                max_age: true,
              }"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                name="Data de Nascimento Segurado"
                label="Data de Nascimento"
                v-mask="'##/##/####'"
                v-model="fieldsWithValidation.birthDate"
                :danger="!!errors.length"
                :disabled="
                  insuredIsMainDriver ||
                  isAlreadyTransmittedOrCanceled ||
                  !canEditAndTransmit
                "
                data-testId="insured-birth-date"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-birth-date-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>

          <div v-if="isPerson" class="vx-col sm:w-1/6 w-full">
            <label for="Sexo de Nascimento" class="vs-select--label"
              >Sexo de Nascimento</label
            >
            <ValidationProvider
              name="Sexo Segurado"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                label="label"
                id="Sexo Segurado"
                v-model="fieldsWithValidation.gender"
                :options="LIST_SEXO"
                :danger="!!errors.length"
                :disabled="
                  insuredIsMainDriver ||
                  isAlreadyTransmittedOrCanceled ||
                  !canEditAndTransmit
                "
                data-testId="insured-gender"
              ></v-select>
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-gender-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>

          <div v-if="isPerson" class="vx-col sm:w-1/6 w-full">
            <label for="Estado Civil" class="vs-select--label"
              >Estado Civil</label
            >
            <ValidationProvider
              name="Estado Civil"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                label="label"
                id="Estado Civil"
                v-model="fieldsWithValidation.maritalStatus"
                :options="LIST_ESTADO_CIVIL"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="insured-select-marital-status"
              ></v-select>
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-marital-status-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>

          <div class="vx-col sm:w-1/6 w-full">
            <div class="flex flex-row items-end w-full">
              <div class="w-full">
                <label for="Celular" class="vs-select--label">Celular</label>
                <ValidationProvider
                  name="Celular"
                  rules="required|min:15|dddValidos|br_phone"
                  v-slot="{ errors }"
                >
                  <the-mask
                    mask="(##) #####-####"
                    id="Celular"
                    class="vs-inputx vs-input--input normal hasValue w-full"
                    v-model="fieldsWithValidation.cellphone"
                    :masked="true"
                    :danger="!!errors.length"
                    data-testId="insured-cellphone"
                    :disabled="
                      (isAlreadyTransmittedOrCanceled &&
                        !editionCellphoneAfterTransmited) ||
                      (!isAlreadyTransmittedOrCanceled && !canEditAndTransmit)
                    "
                  />
                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="insured-cellphone-error"
                    >{{ errors[0] }}</span
                  ></ValidationProvider
                >
              </div>
              <vs-button
                v-if="
                  allowEditionAfterTransmited &&
                  !editionCellphoneAfterTransmited &&
                  !isProposalRefused
                "
                color="primary"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                @click.prevent="openEditionCellphoneAfterTransmited"
              ></vs-button>
            </div>
          </div>

          <div class="vx-col sm:w-1/3 w-full">
            <div class="flex flex-row items-end w-full">
              <div class="w-full">
                <ValidationProvider
                  name="Email"
                  :rules="{ required: true, email: true, max: 75 }"
                  v-slot="{ errors }"
                >
                  <vs-input
                    name="Email"
                    class="w-full"
                    label="E-mail"
                    v-model="fieldsWithValidation.email"
                    maxlength="75"
                    :danger="!!errors.length"
                    type="email"
                    data-testId="insured-email"
                    :disabled="
                      (isAlreadyTransmittedOrCanceled &&
                        !editionEmailAfterTransmited) ||
                      (!isAlreadyTransmittedOrCanceled && !canEditAndTransmit)
                    "
                  />

                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="insured-email-error"
                    >{{ errors[0] }}</span
                  ></ValidationProvider
                >
              </div>
              <vs-button
                v-if="
                  allowEditionAfterTransmited &&
                  !editionEmailAfterTransmited &&
                  !isProposalRefused
                "
                color="primary"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                @click.prevent="openEditionEmailAfterTransmited"
              ></vs-button>
            </div>
          </div>
        </div>

        <div class="flex flex-col w-full items-end">
          <vs-button
            v-if="showCellphoneEmailEditButton && !isProposalRefused"
            :color="colorButton ? `#${colorButton}` : 'success'"
            @click.stop.prevent="updateProposalContactInfo()"
            type="gradient"
            class="mt-2 mb-2 ml-2"
            data-testId="save-button"
            >Salvar Alterações
          </vs-button>
        </div>

        <div v-if="isPerson" class="vx-row mb-4">
          <div class="vx-col sm:w-1/3 w-full checkBoxNomeSocial">
            <vs-checkbox
              v-model="isPoliticallyExposed"
              :disabled="isAlreadyTransmittedOrCanceled || !canEditAndTransmit"
              data-testId="politically-exposed-checkbox"
            >
              É Uma Pessoa Politicamente Exposta (PPE)?
            </vs-checkbox>
          </div>

          <div v-if="isPoliticallyExposed" class="vx-col sm:w-2/3 w-full">
            <ValidationProvider
              name="Tipo de PPE"
              rules="required|max:60"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                label="Tipo de PPE"
                v-model="fieldsWithValidation.ppeDescription"
                id="Tipo de PPE"
                maxlength="60"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="insured-ppe-type"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-ppe-type-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>
        </div>

        <div class="form-part-title mt-6 mb-6">
          <span>Endereço do Segurado</span>
        </div>

        <div class="vx-row mb-4">
          <div class="vx-col sm:w-2/12">
            <label for="Cep Segurado" class="vs-select--label">CEP</label>
            <ValidationProvider
              name="Cep Segurado"
              rules="required|min:10"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                id="Cep Segurado"
                @keyup.native="zipCodeInsured"
                v-model="fieldsWithValidation.address.zipCode"
                maxlength="50"
                :danger="!!errors.length"
                v-mask="'##.###-###'"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="insured-cep"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-cep-error"
              >
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>

          <div class="vx-col sm:w-3/12">
            <label for="Endereco Segurado" class="vs-select--label"
              >Logradouro</label
            >
            <ValidationProvider
              name="Logradouro Segurado"
              rules="required"
              v-slot="{ errors }"
            >
              <vs-input
                v-model="fieldsWithValidation.address.street"
                class="w-full"
                id="Endereco Segurado"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled ||
                  (hasCepApiReturnedInsured && hasCepApiReturnedStreet) ||
                  !canEditAndTransmit
                "
                data-testId="insured-street"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-street-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>

          <div class="vx-col sm:w-3/12 w-full">
            <label for="Bairro Segurado" class="vs-select--label">Bairro</label>
            <ValidationProvider
              name="Bairro Segurado"
              rules="required"
              v-slot="{ errors }"
            >
              <vs-input
                v-model="fieldsWithValidation.address.neighborhood"
                class="w-full"
                id="Bairro Segurado"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled ||
                  (hasCepApiReturnedInsured && hasCepApiReturnedNeighborhood) ||
                  !canEditAndTransmit
                "
                data-testId="insured-neighborhood"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-neighborhood-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>

          <div class="vx-col sm:w-2/12">
            <label for="Número Segurado" class="vs-select--label">Número</label>
            <ValidationProvider
              name="Número Segurado"
              rules="required|max:10"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                id="Número Segurado"
                v-model="fieldsWithValidation.address.number"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="insured-address-number"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-address-number-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>

          <div class="vx-col sm:w-2/12">
            <label for="Complemento Segurado" class="vs-select--label"
              >Complemento</label
            >
            <ValidationProvider
              name="Complemento Segurado"
              rules="max:40"
              v-slot="{ errors }"
            >
              <vs-input
                v-model="fieldsWithValidation.address.complement"
                class="w-full"
                id="Complemento Segurado"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                maxlength="40"
                data-testId="insured-address-compliment"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-address-compliment-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>
        </div>

        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/3 w-full">
            <label for="Estado Segurado" class="vs-select--label">Estado</label>
            <ValidationProvider
              name="Estado Segurado"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                :options="estados"
                id="Estado Segurado"
                autocomplete="off"
                @input="
                  getCityDataInsured(
                    'domMunicipio',
                    'cidades',
                    'nomeCidade',
                    'idCidade',
                  ),
                    selectStateInsured()
                "
                v-model="fieldsWithValidation.address.state"
                placeholder="Selecione o Estado Segurado"
                label="label"
                value="id"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled ||
                  (hasCepApiReturnedInsured && hasCepApiReturnedState) ||
                  !canEditAndTransmit
                "
                data-testId="insured-state"
              ></v-select>
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-state-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>

          <div class="vx-col sm:w-1/3 w-full">
            <label for="Cidade Segurado" class="vs-select--label">Cidade</label>
            <ValidationProvider
              name="Cidade Segurado"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                :options="cidades"
                id="Cidade Segurado"
                @input="selectCityInsured()"
                v-model="fieldsWithValidation.address.city"
                placeholder="Selecione a Cidade"
                label="label"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled ||
                  hasCepApiReturnedInsured ||
                  !canEditAndTransmit
                "
                data-testId="insured-city"
              ></v-select>
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="insured-city-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>
        </div>

        <div class="form-part-title mt-6 mb-6">
          <span>Dados do Condutor</span>
        </div>

        <div class="vx-row mb-4">
          <div v-if="isPerson" class="vx-col sm:w-1/4 w-full">
            <vs-checkbox
              v-model="insuredIsMainDriver"
              disabled
              data-testId="insured-is-main-driver-checkbox"
            >
              Condutor é o segurado?
            </vs-checkbox>
          </div>

          <div class="vx-col sm:w-1/4 w-full">
            <ValidationProvider
              name="CPF-CNPJ condutor"
              rules="required|cpf_cnpj_min|cpf_cnpj"
              v-slot="{ errors }"
            >
              <vs-input
                v-model="fieldsWithValidation.driverCpfCnpj"
                class="w-full"
                label="CPF"
                id="CPF-CNPJ condutor"
                disabled
                v-mask="[DOCUMENT_MASK.CPF, DOCUMENT_MASK.CNPJ]"
                :danger="!!errors.length"
                data-testId="driver-cpf-cnpj"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="driver-cpf-cnpj-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>

          <div
            v-if="
              fieldsWithValidation.driverCpfCnpj.length >=
              DOCUMENT_LENGTH_WITH_MASK.CPF
            "
            class="vx-col sm:w-1/4 w-full"
          >
            <ValidationProvider
              name="Data de Nascimento"
              :rules="{
                required: true,
                date_format: 'dd/MM/yyyy',
                min_age: true,
                max_age: true,
              }"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                label="Data de Nascimento"
                v-mask="'##/##/####'"
                v-model="fieldsWithValidation.driverBirthdate"
                :danger="!!errors.length"
                disabled
                data-testId="driver-birthdate"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="driver-birthdate-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>

          <div
            v-if="
              fieldsWithValidation.driverCpfCnpj.length >=
              DOCUMENT_LENGTH_WITH_MASK.CPF
            "
            class="vx-col sm:w-1/4 w-full"
          >
            <label for="Sexo de Nascimento" class="vs-select--label"
              >Sexo de Nascimento</label
            >
            <ValidationProvider
              name="Sexo"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                label="label"
                id="Sexo"
                v-model="fieldsWithValidation.driverGender"
                :options="LIST_SEXO"
                :danger="!!errors.length"
                disabled
                data-testId="driver-gender"
              ></v-select>
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="driver-gender-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>
        </div>

        <div
          v-if="
            fieldsWithValidation.driverCpfCnpj.length >=
            DOCUMENT_LENGTH_WITH_MASK.CPF
          "
          class="vx-row mb-4"
        >
          <div class="vx-col w-full sm:w-5/12">
            <ValidationProvider
              name="NomeCondutor"
              rules="required|is-person-name"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                label="Nome Completo / Nome Social"
                v-model="fieldsWithValidation.driverName"
                id="NomeCondutor"
                disabled
                :danger="!!errors.length"
                data-testId="driver-name"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="driver-name-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>

          <div
            v-if="
              fieldsWithValidation.driverCpfCnpj.length >=
              DOCUMENT_LENGTH_WITH_MASK.CPF
            "
            class="vx-col w-full sm:w-2/12 checkBoxNomeSocial"
          >
            <vs-checkbox
              disabled
              v-model="driverSocialName"
              data-testId="driver-social-name-checkbox"
            >
              Nome Social?
            </vs-checkbox>
          </div>

          <div v-if="driverSocialName" class="vx-col w-full sm:w-5/12">
            <ValidationProvider
              name="Nome Civil Condutor"
              rules="required|is-person-name"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                label="Nome Civil Condutor"
                v-model="fieldsWithValidation.driverCivilName"
                id="Nome Civil Condutor"
                disabled
                :danger="!!errors.length"
                data-testId="driver-civil-name"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="driver-civil-name-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>

          <div class="vx-col sm:w-1/3 w-full">
            <ValidationProvider
              name="Email Condutor"
              rules="email|max:75"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                label="E-mail"
                v-model="fieldsWithValidation.driverEmail"
                maxlength="75"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                type="email"
                data-testId="driver-email"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="driver-email-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>
        </div>

        <div class="form-part-title mt-6 mb-6">
          <span>CEP de Pernoite</span>
        </div>

        <div class="vx-row mb-4">
          <div class="vx-col sm:w-2/12">
            <label for="Cep" class="vs-select--label">CEP</label>
            <ValidationProvider
              name="CEP"
              rules="required|min:10"
              v-slot="{ errors }"
            >
              <vs-input
                class="w-full"
                id="CEP"
                @keyup.native="keymonitor"
                v-model="fieldsWithValidation.overnightZipCode"
                :danger="!!errors.length"
                v-mask="'##.###-###'"
                disabled
                data-testId="overnight-cep"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="overnight-cep-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>

          <div class="vx-col sm:w-4/12">
            <label for="Endereco" class="vs-select--label">Logradouro</label>
            <ValidationProvider
              name="Logradouro"
              rules="required"
              v-slot="{ errors }"
              ><vs-input
                v-model="fieldsWithValidation.overnightStreet"
                class="w-full"
                id="Endereco"
                :danger="!!errors.length"
                disabled
                data-testId="overnight-street"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="overnight-street-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>
          <div class="vx-col sm:w-2/12 w-full">
            <label for="Bairro" class="vs-select--label">Bairro</label>
            <ValidationProvider
              name="Bairro"
              rules="required"
              v-slot="{ errors }"
            >
              <vs-input
                v-model="overnightNeighborhood"
                class="w-full"
                id="Bairro"
                :danger="!!errors.length"
                disabled
                data-testId="overnight-neighborhood"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="overnight-neighborhood-error"
                >{{ errors[0] }}</span
              >
            </ValidationProvider>
          </div>

          <div class="vx-col sm:w-2/12">
            <label for="Número" class="vs-select--label">Número</label>
            <ValidationProvider
              name="Número"
              rules="required|max:10"
              v-slot="{ errors }"
              ><vs-input
                class="w-full"
                id="Número"
                v-model="fieldsWithValidation.overnightNumber"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="overnight-number"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="overnight-number-hood"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>
          <div class="vx-col sm:w-2/12">
            <label for="Complemento Pernoite" class="vs-select--label"
              >Complemento</label
            >
            <ValidationProvider
              name="Complemento Pernoite"
              rules="max:40"
              v-slot="{ errors }"
            >
              <vs-input
                v-model="fieldsWithValidation.overnightComplement"
                class="w-full"
                id="Complemento Pernoite"
                maxlength="40"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="overnight-address-complement"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="overnight-address-compliment-error"
              >
                {{ errors[0] }}
              </span></ValidationProvider
            >
          </div>
        </div>

        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/2 w-full">
            <label for="Estado" class="vs-select--label">Estado</label>
            <ValidationProvider
              name="Estado"
              rules="required"
              v-slot="{ errors }"
              ><v-select
                :options="estados"
                id="Estado"
                autocomplete="off"
                v-model="fieldsWithValidation.overnightState"
                placeholder="Selecione o Estado"
                label="label"
                value="id"
                :danger="!!errors.length"
                disabled
                data-testId="overnight-state"
              ></v-select>
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="overnight-state-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <label for="Cidade" class="vs-select--label">Cidade</label>
            <ValidationProvider
              name="Cidade"
              rules="required"
              v-slot="{ errors }"
              ><v-select
                :options="cidades"
                id="Cidade"
                v-model="fieldsWithValidation.overnightCity"
                placeholder="Selecione a Cidade"
                label="label"
                :danger="!!errors.length"
                disabled
                data-testId="overnight-city"
              ></v-select>
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="overnight-city-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>
        </div>

        <div class="form-part-title mt-6 mb-6">
          <span>Dados do Veículo</span>
        </div>

        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/6 w-full">
            <vs-checkbox
              disabled
              v-model="isBrandNew"
              data-testId="zero-vehicle-checkbox"
            >
              Veículo Zero
            </vs-checkbox>
          </div>

          <div class="vx-col sm:w-1/5 w-full">
            <label for="" class="vs-select--label">Placa</label>
            <ValidationProvider
              name="Placa"
              :rules="{ required: showPlate, length: 8 }"
              v-slot="{ errors }"
              ><the-mask
                :disabled="disablePlate || !canEditAndTransmit"
                mask="AAA-#XX#"
                style="text-transform: uppercase"
                id="input-2"
                class="vs-inputx vs-input--input normal hasValue w-full"
                v-model="fieldsWithValidation.vehiclePlate"
                :masked="true"
                :danger="!!errors.length"
              />
              <span v-show="!!errors.length" class="text-danger">{{
                errors[0]
              }}</span></ValidationProvider
            >
          </div>
          <div class="vx-col sm:w-1/5 w-full">
            <ValidationProvider
              name="Chassi"
              rules="required|min:17|max:17"
              v-slot="{ errors }"
              ><vs-input
                class="vs-inputx normal hasValue w-full"
                label="Chassi"
                v-model="fieldsWithValidation.vehicleChassis"
                id="Chassi"
                maxlength="17"
                :danger="!!errors.length"
                :disabled="disableChassis || !canEditAndTransmit"
                data-testId="vehicle-chassis"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="vehicle-chassis-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>

          <div v-if="!showPlate" class="vx-col sm:w-1/5 w-full">
            <ValidationProvider
              name="Nº da nota fiscal"
              rules="required"
              v-slot="{ errors }"
              ><vs-input
                class="w-full"
                label="Nº da nota fiscal"
                v-mask="'####################'"
                v-model="fieldsWithValidation.vehicleInvoiceNumber"
                id="numeroNf"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="vehicle-invoice-number"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="vehicle-invoice-number-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>

          <div v-if="!showPlate" class="vx-col sm:w-1/5 w-full">
            <ValidationProvider
              name="Data de emissão da nota fiscal"
              rules="required|date_format:dd/MM/yyyy|less_than_today|min_30days"
              v-slot="{ errors }"
              ><vs-input
                class="w-full"
                label="Data de emissão da nota fiscal"
                v-mask="'##/##/####'"
                v-model="fieldsWithValidation.vehicleInvoiceDate"
                id="dataSaidaNF"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="vehicle-invoice-date"
              />
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="vehicle-invoice-date-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>
        </div>

        <div class="vx-row mb-4">
          <div v-if="!showPlate" class="vx-col sm:w-1/5 w-full">
            <label
              for="Veículo saiu da concessionária"
              class="vs-select--label"
            >
              Veículo saiu da concessionária?
            </label>
            <ValidationProvider
              name="Veículo saiu da concessionária"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                name="Veículo saiu da concessionária"
                :options="outOfDealershipOptions"
                id="Veículo saiu da concessionária"
                v-model="fieldsWithValidation.vehicleIsOutOfDealership"
                :reduce="(item) => item.value"
                :danger="!!errors.length"
                :disabled="
                  isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                "
                data-testId="vehicle-is-outdealership-checkbox"
              ></v-select>
              <span v-show="!!errors.length" class="text-danger"
                >{{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
          <div
            v-if="
              isBrandNew === true &&
              fieldsWithValidation.vehicleIsOutOfDealership === true
            "
            class="vx-col sm:w-1/5 w-full"
          >
            <ValidationProvider
              name="Data de saída da concessionária"
              rules="required|require_invoice_date|less_than_today|after_invoice_date|date_format:dd/MM/yyyy"
              v-slot="{ errors }"
            >
              <label
                for="Data de saída da concessionária"
                class="vs-select--label"
              >
                Data de saída da concessionária
              </label>
              <div class="flex w-full gap-2 items-center">
                <vs-input
                  class="w-full"
                  v-mask="'##/##/####'"
                  v-model="fieldsWithValidation.dealershipExitDate"
                  name="Data de saída da concessionária"
                  id="dealershipExitDate"
                  :danger="!!errors.length"
                  :disabled="
                    isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                  "
                  data-testId="dealership-exit-date"
                />
              </div>
              <span
                v-show="!!errors.length"
                class="text-danger"
                data-testId="dealership-exit-date-error"
                >{{ errors[0] }}</span
              ></ValidationProvider
            >
          </div>
          <div
            v-if="isBrandNew && !!exitDateTooltipText"
            class="vx-col sm:w-1/12 px-0"
          >
            <vs-icon
              v-tooltip="exitDateTooltipText"
              icon="help"
              size="small"
              color="primary"
              class="mt-8"
            ></vs-icon>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div v-if="invoiceDocument" class="vx-col sm:w-1/4 w-full">
            <a :href="invoiceDocument" download> Download da nota fiscal </a>
          </div>

          <div v-if="!selectedFipeModel" class="vx-col sm:w-1/4 w-full">
            <label for="" class="vs-select--label">Marca</label>
            <ValidationProvider name="Marca" rules="required"
              ><v-select
                :options="[fieldsWithValidation.vehicleBrandId]"
                id="Marca"
                @input="getVehicleModels()"
                v-model="fieldsWithValidation.vehicleBrandId"
                label="label"
                disabled
                data-testId="vehicle-brand"
              ></v-select
            ></ValidationProvider>
          </div>

          <div v-if="!selectedFipeModel" class="vx-col sm:w-1/4 w-full">
            <label for="" class="vs-select--label">Modelo</label>
            <ValidationProvider name="Modelo" rules="required">
              <v-select
                :options="vehicleModels"
                id="Modelo"
                @input="getVehicleYears()"
                v-model="fieldsWithValidation.vehicleModelId"
                label="label"
                disabled
                data-testId="vehicle-model"
              ></v-select
            ></ValidationProvider>
          </div>

          <div v-if="!selectedFipeModel" class="vx-col sm:w-1/4 w-full">
            <label for="" class="vs-select--label">Ano Modelo</label>
            <ValidationProvider name="Ano Modelo" rules="required">
              <v-select
                :options="vehicleYearsModel"
                id="Ano Modelo"
                @input="getVehicleModelsByYear()"
                v-model="fieldsWithValidation.vehicleYearModel"
                label="label"
                disabled
                data-testId="vehicle-model-year"
              ></v-select>
            </ValidationProvider>
          </div>

          <div v-if="selectedFipeModel" class="vx-col w-full">
            <vs-alert
              active="true"
              class="vehicle-alert text-light mt-3 p-3 mb-3"
            >
              <p>
                {{ vehicleResult.brand }}/{{ selectedFipeModel.model_text }} -
                {{ vehicleResult.year }}/{{ selectedFipeModel.year_model }}
              </p>
            </vs-alert>
          </div>
        </div>

        <div v-if="fieldsWithValidation.fipeResult" class="vx-row mb-4">
          <div class="vx-col sm:w-1/2 w-full">
            <label for class="vs-input--label">Preço FIPE</label>
            <ValidationProvider
              name="Preço FIPE"
              rules="required"
              v-slot="{ errors }"
            >
              <money
                class="vs-inputx vs-input--input normal"
                id="Preço FIPE"
                v-model="fieldsWithValidation.fipeResult.amount"
                v-bind="money"
                :danger="!!errors.length"
                disabled
                data-testId="vehicle-fipe-value"
              ></money>
              <span v-show="!!errors.length" class="text-danger">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>

          <div class="vx-col sm:w-1/2 w-full container">
            <label>
              Código FIPE:
              <span class="font-bold">
                {{
                  vehicleFipeCode
                    ? vehicleFipeCode
                    : fieldsWithValidation.fipeResult.fipe_code
                }}</span
              >
            </label>
          </div>
        </div>

        <div v-if="increases.length" class="form-part-title mt-6 mb-6">
          <span>Questionário de Avaliação de Risco</span>
        </div>

        <div v-if="increases.length" class="vx-row mb-4">
          <div
            v-for="(item, index) in increases"
            :key="index"
            class="vx-col sm:w-1/3 w-full mb-"
          >
            <label
              :for="item.question"
              class="vs-select--label"
              :data-testId="`increase-question-label-${index}`"
              >{{ item.question }}</label
            >
            <ValidationProvider
              :name="item.question"
              rules="required"
              v-slot="{ errors }"
            >
              <v-select
                :options="item.answers"
                :id="item.question"
                v-model="fieldsWithValidation.increasesAnswers[item.id]"
                label="response"
                placeholder="Selecione"
                :danger="!!errors.length"
                @input="calculate()"
                disabled
                :data-testId="`increase-answer-select-${index}`"
              ></v-select>
              <span v-show="!!errors.length" class="text-danger">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-part-title mt-6 mb-6">
          <span>Produtos e Prêmio</span>
        </div>
        <div class="flex flex-col gap-16 lg:gap-18 mb-4">
          <ProductsList
            :products="products"
            :selectedProducts="selectedProducts"
            disabled
          ></ProductsList>

          <CarregamentosForm
            class="w-full"
            :formData="form"
            :premio="prize ? prize.prize_without_discount : 0"
            :isCanceled="true"
            :enableDiscount="true"
            ref="CarregamentosForm"
            parent="1"
            @recalcular="calculate()"
            :brokerId="brokerId"
            data-testId="carregamentos-form"
          />
        </div>

        <div class="form-part-title mt-6 mb-6">
          <span>Dados do Pagamento</span>
        </div>

        <div class="w-full mb-6 lg:py-2 xl:py-4 2xl:py-10">
          <div class="vx-row">
            <div class="vx-col sm:w-1/4 w-full mb-2">
              <span>Forma de Pagamento</span>
              <ValidationProvider
                name="Forma de Pagamento"
                rules="required"
                v-slot="{ errors }"
                ><v-select
                  :options="paymentMethods"
                  id="Forma de Pagamento"
                  label="paymentName"
                  v-model="fieldsWithValidation.selectedPayment"
                  @input="changePaymentMethod"
                  :danger="!!errors.length"
                  :disabled="
                    isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                  "
                  data-testId="payment-methods-select"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="payment-methods-select-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
            </div>
            <div
              v-if="
                fieldsWithValidation.selectedPayment &&
                (fieldsWithValidation.selectedPayment.id !==
                  PAYMENT_METHODS.CREDIT_CARD.id ||
                  (isAlreadyTransmittedOrCanceled && hasPaidCheckout))
              "
              class="vx-col sm:w-1/2 w-full mb-2"
            >
              <label for="Nº de Parcelas" class="vs-select--label"
                >Nº de Parcelas</label
              >
              <ValidationProvider
                v-if="!isAlreadyTransmittedOrCanceled"
                name="Nº de Parcelas"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="installments"
                  id="Nº de Parcelas"
                  v-model="fieldsWithValidation.payment.installments"
                  label="label"
                  value="id"
                  :danger="!!errors.length"
                  :disabled="
                    isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                  "
                  data-testId="installments-select"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="installments-select-error"
                  >{{ errors[0] }}</span
                >
              </ValidationProvider>
              <ValidationProvider
                v-else
                name="Nº de Parcelas"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  v-model="installmentsText"
                  :value="installmentsText"
                  class="w-full"
                  id="Nº de Parcelas"
                  disabled
                  data-testId="installments-select"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="installments-select-error"
                  >{{ errors[0] }}</span
                ></ValidationProvider
              >
            </div>

            <div v-if="showDueDay" class="vx-col sm:w-1/4 w-full mb-2">
              <label for="Dia do Vencimento" class="vs-select--label"
                >Dia do Vencimento</label
              >
              <ValidationProvider
                :key="showDueDay"
                name="Dia do Vencimento"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="dueDays"
                  id="Dia do Vencimento"
                  v-model="fieldsWithValidation.payment.dueDay"
                  :danger="!!errors.length"
                  :disabled="
                    isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                  "
                  data-testId="due-day-select"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="due-day-select-error"
                >
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div
            v-if="
              fieldsWithValidation.selectedPayment &&
              fieldsWithValidation.selectedPayment.id ===
                PAYMENT_METHODS.AUTOMATIC_DEBIT.id
            "
            class="vx-row"
          >
            <div class="vx-col sm:w-1/3 w-full mb-2">
              <label for="Banco" class="vs-select--label">Banco</label>
              <ValidationProvider
                name="Banco"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :options="banks"
                  id="Banco"
                  v-model="fieldsWithValidation.payment.automaticDebit.bank"
                  :danger="!!errors.length"
                  :disabled="
                    isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                  "
                  data-testId="automatic-debit-bank-select"
                ></v-select>
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="automatic-debit-bank-select-error"
                  >{{ errors[0] }}</span
                ></ValidationProvider
              >
            </div>

            <div class="vx-col sm:w-1/3 w-full mb-2">
              <label for="Agência" class="vs-select--label">Agência</label>
              <ValidationProvider
                name="Agência"
                rules="required|max:4"
                v-slot="{ errors }"
                ><vs-input
                  v-model="fieldsWithValidation.payment.automaticDebit.agency"
                  class="w-full"
                  id="Agência"
                  v-mask="'####'"
                  :danger="!!errors.length"
                  :disabled="
                    isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                  "
                  data-testId="automatic-debit-agency-select"
                />
                <span
                  v-show="!!errors.length"
                  class="text-danger"
                  data-testId="automatic-debit-agency-select-error"
                  >{{ errors[0] }}</span
                ></ValidationProvider
              >
            </div>

            <div
              class="vx-col flex flex-row sm:w-1/3 w-full mb-2 justify-between"
            >
              <div class="w-7/12">
                <label for="Conta Corrente" class="vs-select--label"
                  >Conta Corrente</label
                >
                <ValidationProvider
                  name="Conta Corrente"
                  rules="required|max:20"
                  v-slot="{ errors }"
                >
                  <vs-input
                    v-model="
                      fieldsWithValidation.payment.automaticDebit.account
                    "
                    class="w-full"
                    id="Conta Corrente"
                    v-mask="'####################'"
                    :danger="!!errors.length"
                    :disabled="
                      isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                    "
                    data-testId="automatic-debit-account-select"
                  />
                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="automatic-debit-account-select-error"
                    >{{ errors[0] }}</span
                  ></ValidationProvider
                >
              </div>
              <div class="w-4/12">
                <label for="Digito" class="vs-select--label">Digito</label>
                <ValidationProvider
                  name="Digito"
                  rules="required|max:2"
                  v-slot="{ errors }"
                  ><vs-input
                    v-model="
                      fieldsWithValidation.payment.automaticDebit.accountDigit
                    "
                    class="w-full"
                    id="Digito"
                    v-mask="'#'"
                    :danger="!!errors.length"
                    :disabled="
                      isAlreadyTransmittedOrCanceled || !canEditAndTransmit
                    "
                    data-testId="automatic-debit-account-digit-select"
                  />
                  <span
                    v-show="!!errors.length"
                    class="text-danger"
                    data-testId="automatic-debit-account-digit-select-error"
                    >{{ errors[0] }}</span
                  ></ValidationProvider
                >
              </div>
            </div>
          </div>

          <div class="mt-8">
            <FinancialSummary :prize="prize" isProposition />
          </div>
        </div>
        <div
          v-if="!isLanding"
          class="vx-row"
          :class="fixedButton == true ? 'fixed-buttons' : ''"
        >
          <div class="vx-col sm:w-1/2 text-left">
            <vs-button
              v-if="
                !isAlreadyTransmittedOrCanceled &&
                !isProposalRefused &&
                canEditAndTransmit
              "
              :color="colorButton ? `#${colorButton}` : 'dark'"
              @click.stop.prevent="cancelChanges()"
              type="border"
              class="mt-2 mb-2"
              data-testId="cancel-button"
              >Cancelar
            </vs-button>
          </div>
          <div class="vx-col sm:w-1/2 text-right">
            <vs-button
              v-if="
                !recalculateProductValues &&
                quotation &&
                !isAlreadyTransmittedOrCanceled &&
                !isProposalRefused &&
                canEditAndTransmit
              "
              color="dark"
              @click.stop.prevent="makeDeal()"
              type="gradient"
              class="mt-2 mb-2 ml-2"
              :disabled="dateOrDocumentFieldsInvalid || invalid"
              data-testId="transmit-button"
            >
              Contratar Seguro
            </vs-button>

            <vs-button
              v-if="
                !recalculateProductValues &&
                quotation &&
                !isAlreadyTransmittedOrCanceled &&
                !isProposalRefused &&
                canEditAndTransmit
              "
              :color="colorButton ? `#${colorButton}` : 'success'"
              @click.stop.prevent="updateQuotation()"
              type="gradient"
              class="mt-2 mb-2 ml-2"
              data-testId="save-button"
              >Salvar Alterações
            </vs-button>
          </div>
        </div>

        <TransmissionProposalLoading v-if="proposalLoading" />
      </vx-card>

      <Modal
        v-if="mostrarModalGrupos"
        class="holamundo"
        :title="'Grupo de Veículos'"
        :active.sync="mostrarModalGrupos"
        style="z-index: 99999"
        data-testId="vehicle-groups-popup"
      >
        <vs-list>
          <vs-list-item
            v-for="(coverage, index) in coverages"
            :key="index"
            :title="coverage.name"
            :subtitle="coverage.description"
          >
            <vs-radio
              color="rgb(47,53,102)"
              v-model="vehicleGroupId"
              :vs-value="coverage.id"
              :data-testId="`vehicle-group-radio-${index}`"
            ></vs-radio>
          </vs-list-item>
        </vs-list>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="flex-end">
            <vs-button
              @click="mostrarModalGrupos = false"
              color="primary"
              type="gradient"
              class="mr-3 mt-2 mb-2"
              disabled
              data-testId="choose-vehicle-group"
              >Escolher
            </vs-button>
          </vs-col>
        </vs-row>
      </Modal>

      <Modal
        class="holamundo"
        title="Data de saída da nota fiscal inválida"
        :active.sync="modalInfoDataSaidaNf"
        @close="modalInfoDataSaidaNf = false"
        data-testId="invoice-popup"
      >
        A data da nota fiscal deve ser menor ou igual a hoje.
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              @click="modalInfoDataSaidaNf = false"
              type="gradient"
              color="warning"
              class="mt-5"
              data-testId="invoice-understood-button"
            >
              <feather-icon
                class="text-white"
                icon="CheckIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              Entendi
            </vs-button>
          </div>
        </div>
      </Modal>

      <Modal
        class="holamundo"
        title="Sucesso!"
        :active.sync="showTransmissionMessage"
        @close="goToQuotationsList"
        data-testId="transmission-message-popup"
      >
        <div v-html="successMessage"></div>
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              @click="goToQuotationsList"
              type="gradient"
              color="warning"
              class="mt-5"
              data-testId="transmission-message-understood-button"
            >
              <feather-icon
                class="text-white"
                icon="CheckIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              Entendi
            </vs-button>
          </div>
        </div>
      </Modal>

      <Modal
        class="holamundo"
        title="Falha ao recalcular"
        :active="quotationRecalculateFail"
        data-testId="quotation-recalculate-fail-popup"
        button-close-hidden
      >
        Erro ao recalcular
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              @click="tryRecalculateAgain()"
              type="gradient"
              color="warning"
              class="mt-5"
              data-testId="retry-recalculate-button"
            >
              <feather-icon
                class="text-white"
                icon="CheckIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              Tentar novamente
            </vs-button>
          </div>
        </div>
      </Modal>

      <Modal
        class="holamundo"
        title="Proposta Recusada"
        :active.sync="quotationDenied"
        @close="refreshPage()"
        data-testId="transmission-refused-message-popup"
      >
        <div>
          {{ proposalResponseReason }}.
          <template v-if="bonusDenied && nextBonusClass">
            <br />
            Classe de bônus: {{ nextBonusClass }}.
          </template>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              @click="refreshPage()"
              type="gradient"
              color="warning"
              class="mt-5"
              data-testId="transmission-refused-close-button"
            >
              <feather-icon
                class="text-white"
                icon="CheckIcon"
                svgClasses="h-4 w-4"
              ></feather-icon>
              Fechar
            </vs-button>
          </div>
        </div>
      </Modal>

      <ModalProposalHistory
        v-if="quotation && canShowModalLogs"
        :active.sync="modalLogs"
        :proposal-id="Number(id)"
        @close="closeModalLogs()"
        :refresh="refreshHistory"
        @update:refresh="refreshHistory = false"
      />

      <Modal
        v-if="quotation"
        id="popup-historico-mensageria"
        :title="'Histórico de Mensageria'"
        :active.sync="modalHistoricoMensageria"
        @close="modalHistoricoMensageria = false"
        data-testId="messaging-historic-popup"
      >
        <ModalHistoricoMensageria
          :dadosProposta="{
            idApolice: quotation.id,
            dadosCliente: { idProspect: quotation.prospect.id },
          }"
        ></ModalHistoricoMensageria>
      </Modal>
      <ModalPriceChange
        :isOpen.sync="isPriceChangeModalOpen"
        :oldPrice="oldPrice"
        :newPrice="newPrice"
        @confirm="confirmPriceChange"
        @edit="isPriceChangeModalOpen = false"
      />
    </div>
  </ValidationObserver>
</template>
<script>
import services from '@/services/life-api';
import ModalProposalHistory from '@/views/modais/ModalProposalHistory.vue';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { debounce } from 'lodash';
import { Money } from 'v-money';
import {
  ValidationObserver,
  ValidationProvider,
  Validator,
} from 'vee-validate';
import flatPickr from 'vue-flatpickr-component';
import vSelect from 'vue-select';
import { DDD_BRASIL } from '../../../common/constant/dddsValidos.js';
import Modal from '../../components/Modal.vue';
import {
  DOCUMENT_LENGTH_WITH_MASK,
  DOCUMENT_MASK,
} from '../../constants/cpfCnpj.js';
import { PRICE_CHANGE_THRESHOLD } from '../../constants/executionStages';
import {
  PERMISSIONS_ACTIONS,
  PERMISSIONS_NAMES,
} from '../../constants/permissions.js';
import service from '../../services';
import autoApi from '../../services/auto.api';
import cpfcnpj from '../../services/cpfCnpj.js';
import lifeService from '../../services/life-api.js';
import pricingApi from '../../services/pricing.api.js';
import {
  CONGENERS,
  ID_MOTIVO_RECUSA_CORRETORA_PADRAO,
  LIST_ESTADO_CIVIL,
  LIST_SEXO,
  PAYMENT_METHODS,
  POLICY_STATUSES,
  STATUS_PROPOSTA,
  TIPOS_APOLICES,
} from '../../utils/constants';
import dateConversion from '../../utils/dateConversion';
import functions from '../../utils/functions';
import notify from '../../utils/notify.js';
import TransmissionProposalLoading from '../Includes/transmissionProposalLoading.vue';
import FinancialSummary from '../lists/financialSummary/FinancialSummary.vue';
import ProductsList from '../lists/products/ProductsList.vue';
import CarregamentosForm from '../menu/nova-cotacao-seguradora/components/carregamentosForm';
import NCSv2_utils from '../menu/nova-cotacao-seguradora/utils';
import ModalHistoricoMensageria from '../modais/ModalHistoricoMensageria.vue';
import ModalPriceChange from '../modais/quotations/ModalPriceChange.vue';

export default {
  name: 'editarPropostaAuto',
  props: ['idEmpresaProps', 'isLanding'],
  computed: {
    canEditAndTransmit() {
      return this.$can(
        PERMISSIONS_ACTIONS.EDIT_AND_TRANSMIT_PROPOSAL,
        PERMISSIONS_NAMES.QUOTATIONS,
      );
    },
    saveOrProceedSuccessMessage() {
      return this.deal
        ? 'Proposta transmitida com sucesso'
        : 'Alterações salvas com sucesso';
    },
    saveOrProceedErrorMessage() {
      return this.deal
        ? 'Erro ao transmitir proposta. Tente novamente'
        : 'Erro ao salvar alterações. Tente novamente';
    },
    POLICY_STATUSES() {
      return POLICY_STATUSES;
    },
    STATUS_PROPOSTA() {
      return STATUS_PROPOSTA;
    },
    PAYMENT_METHODS() {
      return PAYMENT_METHODS;
    },
    isMobile() {
      return this.windowWidth <= 768;
    },
    isPerson() {
      if (!this.fieldsWithValidation.cpfcnpj) {
        return true;
      }

      return (
        this.fieldsWithValidation.cpfcnpj.length <=
        this.DOCUMENT_LENGTH_WITH_MASK.CPF
      );
    },
    installmentsText() {
      const interestText = this.quotation.prize.interest > 0 ? 'Com' : 'Sem';
      return `${this.quotation.prize.installments}x ${functions.formataReal(
        this.quotation.prize.monthlyPrize,
      )} - ${interestText} juros`;
    },
    hasPdf() {
      if (this.quotationPdf) {
        return true;
      }
      if (this.proposalPdf) {
        return true;
      }
      return !!this.policyPdf;
    },
    successMessage() {
      if (!this.quotation) {
        return '';
      }

      if (this.quotation.status_id == STATUS_PROPOSTA.AGUARDANDO_APROVACAO.id) {
        return 'Proposta transmitida e <b>aguardando aprovação</b> da BP Seguradora. <br />Acompanhe o status no painel. Nenhuma ação é necessária no momento.';
      }

      if (this.quotation.status_id == STATUS_PROPOSTA.EM_PROCESSO_VISTORIA.id) {
        return 'Proposta transmitida e <b>aguardando envio da vistoria prévia</b>. <br />O link para autovistoria foi enviado por e-mail ou SMS.';
      }

      if (
        this.quotation.status_id == STATUS_PROPOSTA.AGUARDANDO_DADOS_CARTAO.id
      ) {
        return 'Proposta transmitida e <b>aguardando envio dos dados do cartão</b>. <br />O link de checkout foi enviado por e-mail ou SMS.';
      }
      return '';
    },
    isAlreadyTransmittedOrCanceled() {
      if (!this.quotation) {
        return true;
      }
      const quotationStatusId = this.quotation.status_id;
      return (
        functions.isAlreadyTransmitted(quotationStatusId) ||
        quotationStatusId === STATUS_PROPOSTA.COTACAO_CANCELADA.id ||
        quotationStatusId === STATUS_PROPOSTA.COTACAO_RECUSADA.id
      );
    },
    minDateFimVigencia() {
      if (!this.fieldsWithValidation.startOfValidity) {
        return 'today';
      }
      return this.utils.add365Dias(
        this.fieldsWithValidation.startOfValidity,
        0,
      );
    },
    isProposalRefused() {
      return (
        this.quotation &&
        [
          STATUS_PROPOSTA.COTACAO_RECUSADA.id,
          STATUS_PROPOSTA.COTACAO_CANCELADA.id,
          STATUS_PROPOSTA.RECUSADA.id,
          STATUS_PROPOSTA.ESTORNADA.id,
          STATUS_PROPOSTA.AGUARDANDO_ESTORNO.id,
          STATUS_PROPOSTA.APOLICE_CANCELADA.id,
        ].includes(this.quotation.status_id)
      );
    },
    getCreatedAt() {
      if (!this.quotation) {
        return '';
      }
      const createdAt = new Date(this.quotation.created_at);
      return functions.formataDataHoraPadraoBR(createdAt.toISOString(), false);
    },
    getProposalDate() {
      if (!this.quotation) {
        return '';
      }
      const proposalDate = new Date(this.quotation.proposal_date);
      return functions.formataDataHoraPadraoBR(
        proposalDate.toISOString(),
        false,
      );
    },
    isCanceled() {
      if (!this.quotation) {
        return false;
      }

      return [
        STATUS_PROPOSTA.COTACAO_CANCELADA.id,
        STATUS_PROPOSTA.COTACAO_RECUSADA.id,
      ].includes(this.quotation.status_id);
    },
    showPlate() {
      return !this.isBrandNew;
    },
    showManualVehicleInput() {
      return this.isBrandNew || !this.vehicleFound;
    },
    dateOrDocumentFieldsInvalid() {
      return (
        this.requiredStartVigencyDate.invalid ||
        this.requiredPreviousEndVigencyDate.invalid ||
        this.requiredEndVigencyDate.invalid ||
        this.requiredPolicyDocumentBonus.invalid
      );
    },
    blockDiscountBecauseOfBrokerage() {
      if (!this.brokerAccountConfigs) {
        return true;
      }

      if (
        this.form.carregamentos['Corretagem'].porcentagem >
        this.brokerAccountConfigs.max_brokerage_percentage
      ) {
        return true;
      }

      return false;
    },
    blockBecauseOfDiscount() {
      if (!this.brokerAccountConfigs) {
        return true;
      }

      if (this.form.desconto > this.brokerAccountConfigs.max_discount_value) {
        return true;
      }

      const discountPercentage = (this.form.desconto * 100) / this.prize.prize;

      if (
        discountPercentage > this.brokerAccountConfigs.max_discount_percentage
      ) {
        return true;
      }

      return false;
    },
    brandNewFilled() {
      return (
        this.fieldsWithValidation.vehicleChassis &&
        this.fieldsWithValidation.vehicleInvoiceNumber &&
        this.fieldsWithValidation.vehicleInvoiceDate
      );
    },
    getFipeResultArray() {
      return this.mostrarMaisModelosEncontrados
        ? this.vehicleResult.fipe_data
        : this.selectedFipeModel;
    },
    permissaoRecusaCorretora() {
      return this.$can(
        PERMISSIONS_ACTIONS.REJECT_BROKER,
        PERMISSIONS_NAMES.QUOTATIONS,
      );
    },
    isRenovationByCNSeg() {
      return (
        this.fieldsWithValidation.insuranceCompanyCode &&
        this.insuranceCompanies.find(
          (company) =>
            company.id === this.fieldsWithValidation.insuranceCompanyCode,
        ) &&
        ![CONGENERS.NOT_RENEWAL.id, CONGENERS.OTHER.id].includes(
          this.fieldsWithValidation.insuranceCompanyCode,
        )
      );
    },
    requiredStartVigencyDate() {
      return {
        invalid: !this.fieldsWithValidation.startOfValidity,
        message: 'O campo inicio da vigencia é obrigatório',
      };
    },
    hasCepApiReturnedInsured() {
      return !!this.fieldsWithValidation.address.cepApiResult;
    },
    requiredEndVigencyDate() {
      return {
        invalid: !this.fieldsWithValidation.endOfValidity,
        message: 'O campo fim da vigencia é obrigatório',
      };
    },
    requiredPreviousEndVigencyDate() {
      return {
        invalid:
          this.isRenovation &&
          !this.fieldsWithValidation.previousCoverageEndDate,
        message: 'O campo fim da vigência anterior é obrigatório',
      };
    },
    requiredPolicyDocumentBonus() {
      return {
        invalid:
          this.fieldsWithValidation.bonus > 0 &&
          this.isRenovationByCNSeg &&
          !this.policyDocumentBonus &&
          !this.brokerAccountConfigs.cnseg_enabled,
        message: 'O campo Documento da apólice Anterior é obrigatório',
      };
    },
    showDueDay() {
      return (
        (!this.fieldsWithValidation.payment.paymentMethodId ||
          this.fieldsWithValidation.payment.paymentMethodId !==
            PAYMENT_METHODS.CREDIT_CARD.id) &&
        this.fieldsWithValidation.payment.installments &&
        (this.fieldsWithValidation.payment.installments.id > 1 ||
          this.fieldsWithValidation.payment.installments > 1)
      );
    },
    permissionAllowEditionAfterTransmited() {
      return this.$can(
        PERMISSIONS_ACTIONS.EDIT_CONTACT_INFO_AFTER_SUBMISSION,
        PERMISSIONS_NAMES.QUOTATIONS,
      );
    },
    allowEditionAfterTransmited() {
      const notAllowStatus = [
        STATUS_PROPOSTA.RECUSADA.id,
        STATUS_PROPOSTA.FINALIZADO.id,
        STATUS_PROPOSTA.AGUARDANDO_ESTORNO.id,
        STATUS_PROPOSTA.ESTORNADA.id,
        STATUS_PROPOSTA.EM_TRANSMISSAO.id,
        STATUS_PROPOSTA.COTACAO_ABERTA.id,
        STATUS_PROPOSTA.COTACAO_RECUSADA.id,
        STATUS_PROPOSTA.COTACAO_CANCELADA.id,
      ];

      const quotationInAllowStatus =
        this.quotation && !notAllowStatus.includes(this.quotation.status_id);

      return (
        this.permissionAllowEditionAfterTransmited && quotationInAllowStatus
      );
    },
    showCellphoneEmailEditButton() {
      const editionButton =
        this.editionCellphoneAfterTransmited ||
        this.editionEmailAfterTransmited;

      return this.allowEditionAfterTransmited && editionButton;
    },
    hasPaidCheckout() {
      const payment = this.quotation.payment;
      if (!payment || !payment.checkouts || !payment.checkouts.length) {
        return false;
      }
      return payment.checkouts.some((checkout) =>
        ['paid', 'waiting_payment'].includes(checkout.status),
      );
    },
    isBilletSelectedPaymentMethod() {
      return (
        this.fieldsWithValidation.selectedPayment.id ===
        PAYMENT_METHODS.BILLET.id
      );
    },
    isCreditCardSelectedPaymentMethod() {
      return (
        this.fieldsWithValidation.selectedPayment.id ===
        PAYMENT_METHODS.CREDIT_CARD.id
      );
    },
    exitDateTooltipText() {
      if (!this.zeroKMRule || !this.zeroKMRule.tooltipText) {
        return null;
      }
      return this.zeroKMRule.tooltipText;
    },
    isProposal() {
      return (
        this.quotation.proposal_number &&
        ![
          STATUS_PROPOSTA.COTACAO_ABERTA.id,
          STATUS_PROPOSTA.COTACAO_CANCELADA.id,
          STATUS_PROPOSTA.COTACAO_RECUSADA.id,
        ].includes(this.quotation.status_id)
      );
    },
    isPolicy() {
      return (
        this.quotation &&
        this.quotation.policy_status !== POLICY_STATUSES.OPEN.name &&
        [STATUS_PROPOSTA.FINALIZADO.id].includes(this.quotation.status_id)
      );
    },
    canShowModalLogs() {
      return this.$can(
        PERMISSIONS_ACTIONS.SHOW_ALTERATIONS_HISTORY,
        PERMISSIONS_NAMES.QUOTATIONS,
      );
    },
  },
  watch: {
    blockDiscountBecauseOfBrokerage(newVal) {
      if (newVal) {
        this.form.desconto = 0;
      }
    },
    fieldsWithValidation: {
      handler() {
        if (!this.quoatiotionGenerated) return;
        this.validateForm();
      },
      deep: true,
    },
    'fieldsWithValidation.vehicleIsOutOfDealership': {
      handler(newVal) {
        if (!newVal) {
          this.fieldsWithValidation.dealershipExitDate = null;
        }
      },
    },
    async 'fieldsWithValidation.selectedPayment'() {
      if (!this.fieldsWithValidation.selectedPayment) return;
      this.fieldsWithValidation.payment.paymentMethodId =
        this.fieldsWithValidation.selectedPayment.id;
      this.installments = [];

      const payload = {
        prize: this.quotation.prize.tariff_prize,
        monthly_interest:
          this.fieldsWithValidation.selectedPayment.monthlyInterest,
      };

      if (
        !this.isAlreadyTransmittedOrCanceled &&
        this.isBilletSelectedPaymentMethod
      ) {
        this.$vs.loading();
        pricingApi.getInstallments(payload).then((response) => {
          this.$vs.loading.close();
          this.installments = response;
          this.fieldsWithValidation.payment.installments =
            this.installments.find((installment) => {
              return (
                this.fieldsWithValidation.payment.installments ===
                installment.id
              );
            });
        });
      }

      if (
        !this.isAlreadyTransmittedOrCanceled &&
        this.isCreditCardSelectedPaymentMethod
      ) {
        this.calculate();
      }
    },
    'fieldsWithValidation.payment.installments'(value) {
      const installmentIsObject = value && typeof value === 'object';

      if (!installmentIsObject) return;

      const installmentSelected = value.id && value.label && value.total;

      if (installmentSelected) {
        this.calculate();
      }
    },
    'fieldsWithValidation.startOfValidity'() {
      if (this.fieldsWithValidation.startOfValidity) {
        this.fieldsWithValidation.endOfValidity = this.utils.add365Dias(
          this.fieldsWithValidation.startOfValidity,
          0,
        );
        return;
      } else {
        this.fieldsWithValidation.endOfValidity = null;
      }
    },
    'fieldsWithValidation.cpfcnpj'() {
      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverCpfCnpj =
          this.fieldsWithValidation.cpfcnpj;
      }
    },
    'fieldsWithValidation.name'() {
      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverName = this.fieldsWithValidation.name;
      }
    },
    socialName() {
      if (this.insuredIsMainDriver) {
        this.driverSocialName = this.socialName;
      }
    },
    'fieldsWithValidation.civilName'() {
      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverCivilName =
          this.fieldsWithValidation.civilName;
      }
    },
    'fieldsWithValidation.CI': function (newVal) {
      if (newVal && newVal.length === 14) {
        this.$nextTick(() => {
          this.$refs.editForm.validate();
        });
      }
    },
    discount() {
      this.recalculateProductValues = true;
    },
    selectedProducts() {
      this.calculate();
    },
    insuredIsMainDriver() {
      if (this.insuredIsMainDriver) {
        this.fieldsWithValidation.driverCpfCnpj =
          this.fieldsWithValidation.cpfcnpj;
        this.fieldsWithValidation.driverName = this.fieldsWithValidation.name;
        this.driverSocialName = this.socialName;
        this.fieldsWithValidation.driverCivilName =
          this.fieldsWithValidation.civilName;
      } else {
        this.fieldsWithValidation.driverCpfCnpj = '';
        this.fieldsWithValidation.driverName = '';
        this.driverSocialName = false;
        this.fieldsWithValidation.driverCivilName = '';
      }
    },
    isQuotation() {
      return Boolean(this.quotation.id);
    },
    proposalLoading(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  data() {
    const dataAtual = new Date();
    const dataFutura30Dias = new Date();
    dataFutura30Dias.setDate(dataAtual.getDate() + 30);
    return {
      updateSuccessMessage: 'Proposta atualizada com sucesso',
      updateFailMessage: 'Não foi possível atualizar a proposta.',
      DOCUMENT_MASK: DOCUMENT_MASK,
      DOCUMENT_LENGTH_WITH_MASK: DOCUMENT_LENGTH_WITH_MASK,
      fieldsWithValidation: {
        startOfValidity: '',
        endOfValidity: '',
        insuranceCompanyCode: null,
        bonus: null,
        ci: null,
        policyNumber: null,
        previousCoverageEndDate: '',
        isSameVehicle: null,
        cpfcnpj: '',
        name: '',
        ie: null,
        civilName: '',
        birthDate: null,
        gender: null,
        maritalStatus: null,
        cellphone: null,
        email: null,
        ppeDescription: null,
        address: {
          zipCode: '',
          street: null,
          number: null,
          complement: null,
          neighborhood: null,
          city: null,
          state: null,
          cepApiResult: false,
        },
        driverCpfCnpj: '',
        driverBirthdate: null,
        driverGender: null,
        driverName: '',
        driverCivilName: '',
        driverEmail: null,
        overnightZipCode: '',
        overnightStreet: null,
        overnightNumber: null,
        overnightComplement: null,
        overnightState: null,
        overnightCity: null,
        vehiclePlate: '',
        vehicleChassis: null,
        vehicleInvoiceNumber: null,
        vehicleInvoiceDate: '',
        vehicleBrandId: null,
        vehicleModelId: null,
        vehicleYearModel: null,
        fipeResult: null,
        increasesAnswers: {},
        selectedPayment: null,
        vehicleIsOutOfDealership: null,
        dealershipExitDate: null,
        payment: {
          paymentMethodId: null,
          installments: null,
          dueDay: null,
          automaticDebit: {
            bank: null,
            agency: null,
            account: null,
            accountDigit: null,
          },
        },
      },
      TIPO_APOLICES: TIPOS_APOLICES,
      formatStarNumber: functions.formatStarNumber,
      windowWidth: window.innerWidth,
      id: null,
      deal: false,
      key: null,
      quotationDenied: false,
      bonusDenied: false,
      nextBonusClass: null,
      proposalResponseReason: null,
      quotationRecalculateFail: false,
      policyTypes: TIPOS_APOLICES,
      modalLogs: false,
      logsAlteracoes: [],
      colorButton: this.$route.query.colorButton,
      fixedButton: this.$route.query.fixedesabilitaAlterarMarcaButton,
      LIST_SEXO,
      LIST_ESTADO_CIVIL,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      dataFutura30Dias,
      showPanel: this.$route.query.showPanel,
      hideLogo: this.$route.query.hideLogo,
      isInterno: false,
      mostrarModalGrupos: false,
      logo: '',
      brokers: [],
      coverages: [],
      ppeTypes: [],
      dueDays: [],
      brokerId: null,
      isRenovation: null,
      insuranceCompanies: [],
      refreshHistory: false,
      bonusesLevel: [
        {
          id: 0,
          label: 0,
        },
        {
          id: 1,
          label: 1,
        },
        {
          id: 2,
          label: 2,
        },
        {
          id: 3,
          label: 3,
        },
        {
          id: 4,
          label: 4,
        },
        {
          id: 5,
          label: 5,
        },
        {
          id: 6,
          label: 6,
        },
        {
          id: 7,
          label: 7,
        },
        {
          id: 8,
          label: 8,
        },
        {
          id: 9,
          label: 9,
        },
        {
          id: 10,
          label: 10,
        },
      ],
      policyDocumentBonus: null,
      invoiceDocument: null,
      installments: [],
      socialName: false,
      isPoliticallyExposed: false,
      insuredIsMainDriver: false,
      driverSocialName: false,
      overnightNeighborhood: null,
      overnightCepApiResult: false,
      estados: [],
      cidades: [],
      isBrandNew: false,
      vehicleFound: true,
      searchingPlate: false,
      vehicleTypeId: {
        id: 1,
        label: 'Carro',
      },
      vehicleFuelId: null,
      vehicleGroupId: null,
      selectedCoverage: null,
      vehicleBrand: null,
      vehicleModel: null,
      vehicleYearFactory: null,
      vehicleFipeCode: null,
      vehicleColor: null,
      vehiclePorts: null,
      vehicleEngineNumber: null,
      vehicleRenavam: null,
      vehicleCylinderCapacity: null,
      vehicleFuel: null,
      vehiclePassengerQuantity: null,
      modalInfoDataSaidaNf: false,
      placaEncontrada: false,
      vehicleTypes: [],
      increases: [],
      zipCodeIncreases: null,
      increasesOldFormat: [],
      paymentMethods: [],
      vehicleResult: null,
      fuelCode: {
        G: 1,
        A: 2,
        D: 3,
        E: 4,
        F: 5,
        H: 6,
      },
      mostrarMaisModelosEncontrados: false,
      selectedFipeModel: null,
      quotation: null,
      prize: null,
      quoatiotionGenerated: false,
      products: [],
      selectedProducts: [],
      form: {
        carregamentos: {
          'Despesa ADM': { porcentagem: 0 },
          'Margem de Lucro': { porcentagem: 0 },
          Corretagem: { porcentagem: 0 },
          Estipulante: { porcentagem: 0 },
        },
        desconto: 0,
      },
      recalculateProductValues: false,
      discount: 0,
      modalBrokerAccoutBalance: false,
      brokerAccountBalance: 10,
      brokerAccountConfigs: null,
      isSameVehicleOptions: [
        { value: true, label: 'Sim' },
        { value: false, label: 'Não' },
      ],
      outOfDealershipOptions: [
        { value: true, label: 'Sim' },
        { value: false, label: 'Não' },
      ],
      utils: NCSv2_utils,
      banks: ['Itaú', 'Caixa Econômica Federal'],
      quotationPdf: null,
      proposalPdf: null,
      policyPdf: null,
      proposalDate: null,
      subscriptionDate: null,
      showTransmissionMessage: false,
      modalHistoricoMensageria: false,
      disablePlate: false,
      disableChassis: false,
      disableBrand: false,
      disableModel: false,
      disableYearModel: false,
      files: new FormData(),
      editionCellphoneAfterTransmited: false,
      editionEmailAfterTransmited: false,
      hasCepApiReturnedStreet: true,
      hasCepApiReturnedNeighborhood: true,
      hasCepApiReturnedState: true,
      hasCepApiReturnedCity: true,
      proposalLoading: false,
      isPriceChangeModalOpen: false,
      oldPrice: 0,
      newPrice: 0,
      continueQuotation: false,
      ciCache: {},
      zeroKMRule: null,
    };
  },
  methods: {
    updatePdf(res) {
      this.quotationPdf = res.quotation_pdf;
      this.proposalPdf = res.proposal_pdf;
      this.policyPdf = res.policy_pdf;
    },
    validateForm() {
      this.$nextTick(() => {
        this.$refs.editForm.validate();
      });
    },
    handlePriceChange(oldPrice, newPrice) {
      this.oldPrice = oldPrice;
      this.newPrice = newPrice;
      this.isPriceChangeModalOpen = true;
    },
    confirmPriceChange() {
      this.isPriceChangeModalOpen = false;
      this.deal = true;
      this.updateQuotation();
    },
    getConfigDateTimePickerDay() {
      return {
        minDate: this.isAlreadyTransmittedOrCanceled ? null : 'today',
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      };
    },
    updateWidth() {
      this.windowWidth = window.innerWidth;
    },
    filterOptions(options, search) {
      const filtered = options.filter((option) => {
        return (
          option.label.toLowerCase().includes(search.toLowerCase()) ||
          option.label === 'Sim, outra seguradora'
        );
      });

      return filtered;
    },
    getSelectedCongenerLabel(item) {
      const congener = this.insuranceCompanies.find((company) => {
        return company.id === item.id;
      });
      if (congener) {
        return congener.label;
      }
      return item.id === CONGENERS.NOT_RENEWAL.id
        ? CONGENERS.NOT_RENEWAL.label
        : CONGENERS.OTHER.label;
    },
    openModalHistoricoMensageria() {
      this.modalHistoricoMensageria = true;
    },
    goToQuotationsList() {
      this.showTransmissionMessage = false;
      window.location.href = '/Cotacoes';
    },
    getLabelContrato() {
      if (this.subscriptionDate) {
        return 'Apólice';
      }
      if (this.proposalDate) {
        return 'Proposta';
      }
      return 'Cotação';
    },
    getProposalNumberLabel() {
      if (this.isProposal) {
        return `Proposta
      ${this.formatStarNumber(
        this.quotation.proposal_number,
        this.TIPO_APOLICES.AUTO,
        'PROPOSAL',
      )}
      - AUTO`;
      }
      return `${this.getLabelContrato()} ${this.quotation.proposal_id} - AUTO`;
    },
    openPdf() {
      let link = null;
      const proposalLink = this.proposalPdf
        ? this.proposalPdf
        : `/contratoProposta/${this.key}`;
      switch (this.getLabelContrato()) {
        case 'Apólice':
          link = this.policyPdf
            ? this.policyPdf
            : `/contratoProposta/${this.key}`;
          break;
        case 'Proposta':
          link = proposalLink;
          break;
        case 'Cotação':
          link = this.quotationPdf
            ? this.quotationPdf
            : `/contratoCotacao/${this.key}`;
          break;
        default:
          link = proposalLink;
      }
      window.open(link, '_blank');
    },
    tryRecalculateAgain() {
      this.quotationRecalculateFail = false;
      this.calculate();
    },
    changePaymentMethod() {
      this.$nextTick(() => {
        this.$validator.reset('Nº de Parcelas');
        this.$validator.reset('Dia do Vencimento');
        this.fieldsWithValidation.payment.installments = {};
        this.fieldsWithValidation.payment.dueDay = null;
      });
    },
    getPayloadRecalculate() {
      const formatedIncreases = [];

      for (const id of Object.keys(
        this.fieldsWithValidation.increasesAnswers,
      )) {
        formatedIncreases.push({
          id: Number(id),
          answers: this.fieldsWithValidation.increasesAnswers[id].id,
        });
      }

      const [day, month, year] = this.fieldsWithValidation.driverBirthdate
        .split('/')
        .map(Number);
      const driverBirthdate = new Date(year, month - 1, day, 0, 0, 0);

      let dateNf = null;

      if (this.fieldsWithValidation.vehicleInvoiceDate) {
        const [dayNf, monthNf, yearNf] =
          this.fieldsWithValidation.vehicleInvoiceDate.split('/').map(Number);
        dateNf = new Date(yearNf, monthNf - 1, dayNf, 0, 0, 0);
      }

      return {
        broker_id: this.brokerId,
        prospect: {
          tax_id: this.fieldsWithValidation.cpfcnpj,
          name: this.fieldsWithValidation.name,
          social_name: this.socialName,
          civil_name: this.fieldsWithValidation.civilName,
        },
        driver: {
          tax_id: this.fieldsWithValidation.driverCpfCnpj,
          name: this.fieldsWithValidation.driverName,
          social_name: this.driverSocialName,
          civil_name: this.fieldsWithValidation.driverCivilName,
          gender: this.fieldsWithValidation.driverGender,
          birthdate: driverBirthdate.toISOString(),
        },
        overnight_address: {
          zip_code: this.fieldsWithValidation.overnightZipCode.replace('.', ''),
          street: this.fieldsWithValidation.overnightStreet,
          neighborhood: this.overnightNeighborhood,
          city: this.fieldsWithValidation.overnightCity,
          state: this.fieldsWithValidation.overnightState,
        },
        addition_information: {
          is_renovation: this.fieldsWithValidation.insuranceCompanyCode != '1',
          bonus: this.fieldsWithValidation.bonus,
          insurance_company_code:
            this.fieldsWithValidation.insuranceCompanyCode,
          policy_number: this.fieldsWithValidation.policyNumber,
          policy_document_bonus: this.policyDocumentBonus,
        },
        vehicle: {
          type_id: Number(this.vehicleTypeId.id),
          brand_id: Number(this.fieldsWithValidation.vehicleBrandId.id),
          model_id: Number(this.fieldsWithValidation.vehicleModelId.id),
          plate: this.fieldsWithValidation.vehiclePlate,
          chassis: this.fieldsWithValidation.vehicleChassis,
          coverageValue: Number(
            this.fieldsWithValidation.fipeResult.amount
              .replace('R$ ', '')
              .replace('.', '')
              .replace(',', '.'),
          ),
          is_brand_new: this.isBrandNew,
          invoice_number: this.fieldsWithValidation.vehicleInvoiceNumber,
          invoice_date: !this.fieldsWithValidation.vehicleInvoiceDate
            ? null
            : functions.formataDataHoraPadraoBR(dateNf.toISOString(), false),
          out_daelership: this.fieldsWithValidation.vehicleIsOutOfDealership,
          brand: this.vehicleBrand
            ? this.vehicleBrand
            : this.fieldsWithValidation.fipeResult.brand,
          model: this.vehicleModel
            ? this.vehicleModel
            : this.fieldsWithValidation.fipeResult.model,
          year_model: Number(this.fieldsWithValidation.vehicleYearModel.year),
          year_factory: Number(this.vehicleYearFactory),
          fipe_code: this.vehicleFipeCode
            ? this.vehicleFipeCode
            : this.fieldsWithValidation.fipeResult.fipe_code,
          color: this.vehicleColor,
          ports: this.vehiclePorts,
          engine_number: this.vehicleEngineNumber,
          renavam: this.vehicleRenavam,
          cylinder_capacity: Number(this.vehicleCylinderCapacity),
          fuel: this.vehicleFuel
            ? this.vehicleFuel
            : this.fieldsWithValidation.fipeResult.fuel,
          passenger_quantity: this.vehiclePassengerQuantity,
          plate_result: this.vehicleResult
            ? JSON.stringify(this.vehicleResult)
            : null,
          fipe_result: this.fieldsWithValidation.fipeResult
            ? JSON.stringify(this.fieldsWithValidation.fipeResult)
            : null,
          invoice_document: this.invoiceDocument,
        },
        increases: formatedIncreases,
        payment: this.fieldsWithValidation.selectedPayment
          ? {
              payment_method_id: this.fieldsWithValidation.selectedPayment.id,
              installments: this.isBilletSelectedPaymentMethod
                ? this.fieldsWithValidation.payment.installments.id
                : null,
              monthly_interest: this.isBilletSelectedPaymentMethod
                ? this.fieldsWithValidation.selectedPayment.monthlyInterest[
                    this.fieldsWithValidation.payment.installments.id
                  ] || 0
                : null,
              due_day: this.fieldsWithValidation.payment.dueDay,
              automatic_debit:
                this.fieldsWithValidation.selectedPayment.id == 5
                  ? {
                      bank: this.fieldsWithValidation.payment.automaticDebit
                        .bank,
                      agency:
                        this.fieldsWithValidation.payment.automaticDebit.agency,
                      account:
                        this.fieldsWithValidation.payment.automaticDebit
                          .account,
                      accountDigit:
                        this.fieldsWithValidation.payment.automaticDebit
                          .accountDigit,
                    }
                  : null,
            }
          : null,
      };
    },
    calculate() {
      if (!this.quotation) {
        return;
      }

      if (this.quotation.status_id != STATUS_PROPOSTA.EM_TRANSMISSAO.id) {
        return;
      }

      const formatedCharges = [];

      for (const carregamento of Object.keys(this.form.carregamentos)) {
        const charge = this.form.carregamentos[carregamento];
        formatedCharges.push({
          id: charge.idCarregamento,
          percentage: Number(charge.porcentagem),
        });
      }

      const payload = this.getPayloadRecalculate();
      const updatePayload = {
        id: this.quotation.id,
        charges: formatedCharges,
        coverage_products: [...this.selectedProducts],
        discount:
          this.form.desconto && typeof this.form.desconto === 'string'
            ? Number(
                this.form.desconto
                  .replace('R$ ', '')
                  .replace('.', '')
                  .replace(',', '.'),
              )
            : this.form.desconto && typeof this.form.desconto === 'number'
            ? this.form.desconto
            : 0,
      };

      autoApi
        .recalculate(this.quotation.id, { ...payload, ...updatePayload })
        .then((res) => {
          this.prize = res.prize;
          this.recalculateProductValues = false;
          this.quotationRecalculateFail = false;
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            this.quotationDenied = true;
            const message = error.response.data.message || '';
            if (message) this.proposalResponseReason = message;
            return;
          }

          this.quotationRecalculateFail = true;
        });
    },
    makeDeal() {
      this.deal = true;
      this.updateQuotation();
    },
    updateProposalContactInfo() {
      autoApi
        .updateProposalContactInfo(this.quotation.id, {
          cellphone: this.fieldsWithValidation.cellphone,
          email: this.fieldsWithValidation.email,
        })
        .then((res) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: this.updateSuccessMessage,
            color: 'success',
          });
          this.editionEmailAfterTransmited = false;
          this.editionCellphoneAfterTransmited = false;
          this.updatePdf(res);
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: this.updateFailMessage,
            color: 'danger',
          });
        });
    },
    parseRefusalMessage(raw) {
      try {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.text) return parsed;
      } catch (error) {
        return { text: raw };
      }
      return { text: raw };
    },
    handleUpdateQuotationError(error) {
      if (error.response && error.response.status === 422) {
        this.quotationDenied = true;
        const raw = error.response.data.message || '';
        const parsed = this.parseRefusalMessage(raw);

        this.proposalResponseReason = parsed.text || raw;

        if (parsed.isBonusValid === false) {
          this.bonusDenied = true;
          this.nextBonusClass = parsed.nextBonus;
          return;
        }

        return;
      }

      const customErrorMessageStatuses = [409, 503];
      const customErrorMessage =
        error.response &&
        error.response.data &&
        error.response.data.message &&
        customErrorMessageStatuses.includes(error.response.status)
          ? error.response.data.message
          : null;
      notify.notifyFail(
        this.$vs,
        customErrorMessage || this.saveOrProceedErrorMessage,
      );
    },
    updateQuotation() {
      const formatedCharges = [];
      const totalPrize = this.prize.prize;
      const tariffPrize = this.prize.tariff_prize;

      for (const carregamento of Object.keys(this.form.carregamentos)) {
        const charge = this.form.carregamentos[carregamento];
        formatedCharges.push({
          id: charge.idCarregamento,
          percentage: Number(charge.porcentagem),
        });
      }

      const payload = this.getBasePayload();

      const updatePayload = {
        id: this.quotation.id,
        charges: formatedCharges,
        coverage_products: [...this.selectedProducts],
        discount:
          this.form.desconto && typeof this.form.desconto === 'string'
            ? Number(
                this.form.desconto
                  .replace('R$ ', '')
                  .replace('.', '')
                  .replace(',', '.'),
              )
            : 0,
        deal: this.deal,
      };

      this.handleLoading(true, true);

      autoApi
        .transmitProposal(this.quotation.id, { ...payload, ...updatePayload })
        .then((res) => {
          this.handleLoading(false, false);

          this.quotation = res;
          this.prize = res.prize;

          const hasSignificantPriceChange =
            Math.abs(tariffPrize - this.prize.tariff_prize) >=
            PRICE_CHANGE_THRESHOLD;
          if (hasSignificantPriceChange && this.deal) {
            this.handlePriceChange(totalPrize, this.prize.prize);
            this.deal = false;
            this.$vs.loading.close();
            return;
          }
          this.$vs.loading.close();

          this.recalculateProductValues = false;

          this.showTransmissionMessage = this.deal ? true : false;

          this.updatePdf(res);

          notify.notifySuccess(this.$vs, this.saveOrProceedSuccessMessage);
        })
        .catch((error) => {
          this.handleLoading(false, false);
          this.handleUpdateQuotationError(error);
        })
        .finally(() => {
          this.deal = false;
          this.refreshHistory = true;
        });
    },
    handleLoading(value, vs) {
      if (this.deal) {
        this.proposalLoading = value;
      } else {
        if (vs) {
          this.$vs.loading();
        } else {
          this.$vs.loading.close();
        }
      }
    },
    refreshPage() {
      this.quotationDenied = false;
      this.bonusDenied = false;
      this.nextBonusClass = null;
      this.proposalResponseReason = null;
      window.location.href = '/Cotacoes';
    },
    setDefaultSelectedProducts() {
      this.selectedProducts = this.products.filter(
        (product) => Boolean(product.mandatory) || product.input === 'slider',
      );
      this.selectedProducts = this.selectedProducts.map((product) => {
        if (product.input === 'select') {
          return { id: product.id, quantity: 0 };
        }
        if (product.input === 'slider') {
          return { id: product.id, quantity: product.min || 0 };
        }
      });
    },
    getBasePayload() {
      const formatedIncreases = [];

      for (const id of Object.keys(
        this.fieldsWithValidation.increasesAnswers,
      )) {
        formatedIncreases.push({
          id: Number(id),
          answers: this.fieldsWithValidation.increasesAnswers[id].id,
        });
      }

      const [day, month, year] = this.fieldsWithValidation.driverBirthdate
        .split('/')
        .map(Number);
      const driverBirthdate = new Date(year, month - 1, day, 0, 0, 0);

      let insuredBirthdate = false;
      if (this.isPerson && this.fieldsWithValidation.birthDate) {
        const [dayInsured, monthInsured, yearInsured] =
          this.fieldsWithValidation.birthDate.split('/').map(Number);
        insuredBirthdate = new Date(
          yearInsured,
          monthInsured - 1,
          dayInsured,
          0,
          0,
          0,
        );
      }

      let startOfValidity = null;
      if (this.fieldsWithValidation.startOfValidity) {
        const [dayStartOfValidity, monthStartOfValidity, yearStartOfValidity] =
          this.fieldsWithValidation.startOfValidity.split('/').map(Number);
        startOfValidity = new Date(
          yearStartOfValidity,
          monthStartOfValidity - 1,
          dayStartOfValidity,
          0,
          0,
          0,
        );
      }

      let endOfValidity = null;
      if (this.fieldsWithValidation.endOfValidity) {
        const [dayEndOfValidity, monthEndOfValidity, yearEndOfValidity] =
          this.fieldsWithValidation.endOfValidity.split('/').map(Number);
        endOfValidity = new Date(
          yearEndOfValidity,
          monthEndOfValidity - 1,
          dayEndOfValidity,
          0,
          0,
          0,
        );
      }

      let previousCoverageEndDate = null;
      if (this.fieldsWithValidation.previousCoverageEndDate) {
        const [dayEndOfValidity, monthEndOfValidity, yearEndOfValidity] =
          this.fieldsWithValidation.previousCoverageEndDate
            .split('/')
            .map(Number);
        previousCoverageEndDate = new Date(
          yearEndOfValidity,
          monthEndOfValidity - 1,
          dayEndOfValidity,
          0,
          0,
          0,
        );
      }

      let dateNf = null;

      if (this.fieldsWithValidation.vehicleInvoiceDate) {
        const [dayNf, monthNf, yearNf] =
          this.fieldsWithValidation.vehicleInvoiceDate.split('/').map(Number);
        dateNf = new Date(yearNf, monthNf - 1, dayNf, 0, 0, 0);
      }

      return {
        broker_id: this.brokerId,
        start_of_validity: startOfValidity
          ? startOfValidity.toISOString().split('T')[0]
          : null,
        end_of_validity: endOfValidity
          ? endOfValidity.toISOString().split('T')[0]
          : null,
        prospect: {
          tax_id: this.fieldsWithValidation.cpfcnpj,
          name: this.fieldsWithValidation.name,
          social_name: this.socialName,
          civil_name: this.fieldsWithValidation.civilName,
          birthdate:
            this.isPerson && insuredBirthdate
              ? insuredBirthdate.toISOString().split('T')[0]
              : null,
          gender: this.fieldsWithValidation.gender,
          marital_status: this.fieldsWithValidation.maritalStatus,
          email: this.fieldsWithValidation.email,
          cellphone: this.fieldsWithValidation.cellphone,
          is_politically_exposed: this.isPoliticallyExposed,
          ppe_description: this.fieldsWithValidation.ppeDescription,
          state_registration_number: this.fieldsWithValidation.ie,
          address: {
            zip_code: this.fieldsWithValidation.address.zipCode
              ? this.fieldsWithValidation.address.zipCode.replace('.', '')
              : null,
            street: this.fieldsWithValidation.address.street,
            number: this.fieldsWithValidation.address.number,
            complement: this.fieldsWithValidation.address.complement,
            neighborhood: this.fieldsWithValidation.address.neighborhood,
            city: this.fieldsWithValidation.address.city,
            state: this.fieldsWithValidation.address.state,
            is_cep_api_result: this.fieldsWithValidation.address.cepApiResult,
          },
        },
        driver: {
          tax_id: this.fieldsWithValidation.driverCpfCnpj,
          name: this.fieldsWithValidation.driverName,
          social_name: this.driverSocialName,
          civil_name: this.fieldsWithValidation.driverCivilName,
          gender: this.fieldsWithValidation.driverGender,
          birthdate: driverBirthdate.toISOString().split('T')[0],
          email: this.fieldsWithValidation.driverEmail,
        },
        overnight_address: {
          zip_code: this.fieldsWithValidation.overnightZipCode.replace('.', ''),
          street: this.fieldsWithValidation.overnightStreet,
          neighborhood: this.overnightNeighborhood,
          city: this.fieldsWithValidation.overnightCity,
          state: this.fieldsWithValidation.overnightState,
          number: this.fieldsWithValidation.overnightNumber,
          complement: this.fieldsWithValidation.overnightComplement,
          is_cep_api_result: this.overnightCepApiResult,
        },
        addition_information: {
          is_renovation: this.fieldsWithValidation.insuranceCompanyCode != '1',
          bonus: this.fieldsWithValidation.bonus,
          insurance_company_code:
            this.fieldsWithValidation.insuranceCompanyCode,
          policy_number: this.fieldsWithValidation.policyNumber,
          ci: this.fieldsWithValidation.ci,
          policy_document_bonus: this.policyDocumentBonus,
          previous_coverage_end_date: previousCoverageEndDate,
          is_same_vehicle: this.fieldsWithValidation.isSameVehicle,
        },
        vehicle: {
          type_id: Number(this.vehicleTypeId.id),
          brand_id: this.fieldsWithValidation.vehicleBrandId
            ? Number(this.fieldsWithValidation.vehicleBrandId.id)
            : null,
          model_id: this.fieldsWithValidation.vehicleModelId
            ? Number(this.fieldsWithValidation.vehicleModelId.id)
            : null,
          plate: this.fieldsWithValidation.vehiclePlate,
          chassis: this.fieldsWithValidation.vehicleChassis,
          coverageValue: Number(
            this.fieldsWithValidation.fipeResult.amount
              .replace('R$ ', '')
              .replace('.', '')
              .replace(',', '.'),
          ),
          is_brand_new: this.isBrandNew,
          invoice_number: this.fieldsWithValidation.vehicleInvoiceNumber,
          invoice_date: !this.fieldsWithValidation.vehicleInvoiceDate
            ? null
            : functions.formataDataHoraPadraoBR(dateNf.toISOString(), false),
          out_daelership: this.fieldsWithValidation.vehicleIsOutOfDealership,
          dealership_exit_date: this.getDealershipExitDate(),
          brand: this.vehicleBrand
            ? this.vehicleBrand
            : this.fieldsWithValidation.fipeResult.brand,
          model: this.vehicleModel
            ? this.vehicleModel
            : this.fieldsWithValidation.fipeResult.model,
          year_model: Number(this.fieldsWithValidation.vehicleYearModel.year),
          year_factory: Number(this.vehicleYearFactory),
          fipe_code: this.vehicleFipeCode
            ? this.vehicleFipeCode
            : this.fieldsWithValidation.fipeResult.fipe_code,
          color: this.vehicleColor,
          ports: this.vehiclePorts,
          engine_number: this.vehicleEngineNumber,
          renavam: this.vehicleRenavam,
          cylinder_capacity: Number(this.vehicleCylinderCapacity),
          fuel: this.vehicleFuel
            ? this.vehicleFuel
            : this.fieldsWithValidation.fipeResult.fuel,
          passenger_quantity: this.vehiclePassengerQuantity,
          plate_result: this.vehicleResult
            ? JSON.stringify(this.vehicleResult)
            : null,
          fipe_result: this.fieldsWithValidation.fipeResult
            ? JSON.stringify(this.fieldsWithValidation.fipeResult)
            : null,
          invoice_document: this.invoiceDocument,
        },
        increases: formatedIncreases,
        payment: {
          payment_method_id: this.fieldsWithValidation.selectedPayment
            ? this.fieldsWithValidation.selectedPayment.id
            : null,
          monthly_interest:
            this.fieldsWithValidation.payment.installments &&
            this.fieldsWithValidation.selectedPayment
              ? this.fieldsWithValidation.selectedPayment.monthlyInterest[
                  this.fieldsWithValidation.payment.installments.id ||
                    this.fieldsWithValidation.payment.installments
                ] || 0
              : 0,
          installments: this.getInstallmentsPayload(),
          due_day: this.fieldsWithValidation.payment.dueDay,
          automatic_debit:
            this.fieldsWithValidation.selectedPayment &&
            this.fieldsWithValidation.selectedPayment.id == 5
              ? {
                  bank: this.fieldsWithValidation.payment.automaticDebit.bank,
                  agency:
                    this.fieldsWithValidation.payment.automaticDebit.agency,
                  account:
                    this.fieldsWithValidation.payment.automaticDebit.account,
                  accountDigit:
                    this.fieldsWithValidation.payment.automaticDebit
                      .accountDigit,
                }
              : null,
        },
      };
    },
    getDealershipExitDate() {
      if (this.fieldsWithValidation.dealershipExitDate) {
        const [day, month, year] = this.fieldsWithValidation.dealershipExitDate
          .split('/')
          .map(Number);
        return new Date(year, month - 1, day, 0, 0, 0)
          .toISOString()
          .split('T')[0];
      }
      return null;
    },
    getBrokerAccountConfigs() {
      autoApi
        .getBrokerAccountConfigs()
        .then((res) => {
          this.brokerAccountConfigs = res;
          this.form.maximoDesconto = this.brokerAccountConfigs;
        })
        .catch(() => {
          notify.notifyFail(
            this.$vs,
            'Não foi possível buscar as configurações da conta corrente',
          );
        });
    },
    getBrokers() {
      autoApi
        .getBrokers()
        .then((res) => {
          if (res.data && res.data.length) {
            this.brokers = res;
          }
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao buscar as corretoras');
        });
    },

    getDueDays() {
      autoApi
        .getDueDays()
        .then((res) => {
          if (res && Array.isArray(res)) {
            this.dueDays = res.sort((a, b) => a - b);
          }
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao buscar os dias de vencimento');
        });
    },
    getInstallmentsPayload() {
      const installments = this.fieldsWithValidation.payment.installments;
      if (typeof installments === 'number') {
        return installments;
      }
      if (installments && installments.id) return installments.id;

      return 1;
    },
    getPaymentMethods() {
      autoApi
        .getPaymentMethods()
        .then((res) => {
          this.paymentMethods = res;
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao buscar as formas de pagamento');
        });
    },
    getQuotation() {
      this.$vs.loading();
      autoApi
        .getQuotation(this.id)
        .then((res) => {
          this.quotation = res;
          this.brokerId = res.broker.id;
          this.insuredIsMainDriver = res.prospect.tax_id === res.driver.tax_id;

          this.fieldsWithValidation.startOfValidity =
            dateConversion.convertISOToDate(res.start_of_validity);
          this.fieldsWithValidation.endOfValidity =
            dateConversion.convertISOToDate(res.end_of_validity);
          this.fieldsWithValidation.ci = res.addition_information.ci;
          this.fieldsWithValidation.insuranceCompanyCode =
            res.addition_information.insurance_company_code;
          this.fieldsWithValidation.policyNumber =
            res.addition_information.policy_number;
          this.policyDocumentBonus =
            res.addition_information.policy_document_bonus;
          this.fieldsWithValidation.isSameVehicle = res.vehicle.is_brand_new
            ? false
            : res.addition_information.is_same_vehicle;
          this.fieldsWithValidation.previousCoverageEndDate =
            dateConversion.convertISOToDate(
              res.addition_information.previous_coverage_end_date,
            );

          this.quotationPdf = res.quotation_pdf;
          this.proposalPdf = res.proposal_pdf;
          this.policyPdf = res.policy_pdf;
          this.proposalDate = res.proposal_date;
          this.subscriptionDate = res.subscription_date;
          this.key = res.key;

          this.isRenovation = res.addition_information.is_renovation;
          this.fieldsWithValidation.bonus = res.addition_information.bonus;

          this.fieldsWithValidation.cpfcnpj = res.prospect.tax_id;
          this.fieldsWithValidation.name = res.prospect.name;
          this.socialName = res.prospect.social_name;
          this.fieldsWithValidation.civilName = res.prospect.civil_name;
          this.fieldsWithValidation.birthDate = dateConversion.convertISOToDate(
            res.prospect.birthdate,
          );
          this.fieldsWithValidation.gender = res.prospect.gender;
          this.fieldsWithValidation.maritalStatus = res.prospect.marital_status;
          this.fieldsWithValidation.cellphone = res.prospect.cellphone;
          this.fieldsWithValidation.email = res.prospect.email;
          this.isPoliticallyExposed = res.prospect.is_politically_exposed;
          this.fieldsWithValidation.ppeDescription =
            res.prospect.ppe_description;
          this.fieldsWithValidation.ie = res.prospect.stateRegistrationNumber;

          this.fieldsWithValidation.address.zipCode =
            res.prospect.address.zip_code;
          this.fieldsWithValidation.address.street =
            res.prospect.address.street;
          this.fieldsWithValidation.address.number =
            res.prospect.address.number;
          this.fieldsWithValidation.address.complement =
            res.prospect.address.complement;
          this.fieldsWithValidation.address.neighborhood =
            res.prospect.address.neighborhood;
          this.fieldsWithValidation.address.city = res.prospect.address.city;
          this.fieldsWithValidation.address.state = res.prospect.address.state;
          this.fieldsWithValidation.address.cepApiResult =
            res.prospect.address.is_cep_api_result;

          this.fieldsWithValidation.driverCpfCnpj = res.driver.tax_id;
          this.fieldsWithValidation.driverName = res.driver.name;
          this.driverSocialName = res.driver.social_name;
          this.fieldsWithValidation.driverCivilName = res.driver.civil_name;
          this.fieldsWithValidation.driverGender = res.driver.gender;
          this.fieldsWithValidation.driverBirthdate =
            dateConversion.convertISOToDate(res.driver.birthdate);
          this.fieldsWithValidation.driverEmail = res.driver.email;

          this.fieldsWithValidation.selectedPayment = this.paymentMethods.find(
            (pay) => pay.id == res.payment.payment_method_id,
          );
          this.fieldsWithValidation.payment.installments =
            res.payment.installments;
          this.fieldsWithValidation.payment.dueDay = res.payment.due_day;

          if (res.payment.automatic_debit) {
            this.fieldsWithValidation.payment.automaticDebit.bank =
              res.payment.automatic_debit.bank;
            this.fieldsWithValidation.payment.automaticDebit.agency =
              res.payment.automatic_debit.agency;
            this.fieldsWithValidation.payment.automaticDebit.account =
              res.payment.automatic_debit.account;
            this.fieldsWithValidation.payment.automaticDebit.accountDigit =
              res.payment.automatic_debit.accountDigit;
          }

          this.fieldsWithValidation.overnightZipCode =
            res.overnight_address.zip_code;
          this.fieldsWithValidation.overnightStreet =
            res.overnight_address.street;
          this.overnightNeighborhood = res.overnight_address.neighborhood;
          this.fieldsWithValidation.overnightCity = res.overnight_address.city;
          this.fieldsWithValidation.overnightState =
            res.overnight_address.state;
          this.fieldsWithValidation.overnightNumber =
            res.overnight_address.number;
          this.fieldsWithValidation.overnightComplement =
            res.overnight_address.complement;
          this.overnightCepApiResult = res.overnight_address.is_cep_api_result;

          this.vehicleTypeId = this.vehicleTypes.find(
            (vehicleType) => vehicleType.id === res.vehicle.type_id,
          );
          this.fieldsWithValidation.vehicleBrandId = {
            id: res.vehicle.brand_id,
          };
          this.fieldsWithValidation.vehicleModelId = {
            id: res.vehicle.model_id,
          };
          this.fieldsWithValidation.vehicleYearModel = {
            year: res.vehicle.year_model,
          };

          this.vehicleGroupId = res.vehicle.group_id;
          this.fieldsWithValidation.vehiclePlate = res.vehicle.plate;
          this.fieldsWithValidation.vehicleChassis = res.vehicle.chassis;

          this.isBrandNew = res.vehicle.is_brand_new;
          this.fieldsWithValidation.vehicleInvoiceDate =
            res.vehicle.invoice_date;
          this.fieldsWithValidation.vehicleIsOutOfDealership =
            res.vehicle.out_daelership;
          this.fieldsWithValidation.dealershipExitDate = res.vehicle
            .dealership_exit_date
            ? res.vehicle.dealership_exit_date.split('-').reverse().join('/')
            : null;
          this.fieldsWithValidation.vehicleInvoiceNumber =
            res.vehicle.invoice_number;

          this.vehicleBrand = res.vehicle.brand;
          this.fieldsWithValidation.vehicleBrandId = {
            ...this.fieldsWithValidation.vehicleBrandId,
            label: res.vehicle.brand,
          };
          this.vehicleModel = res.vehicle.model;
          this.fieldsWithValidation.vehicleModelId = {
            ...this.fieldsWithValidation.vehicleModelId,
            label: res.vehicle.model,
          };
          this.vehicleYearFactory = res.vehicle.year_factory;
          this.fieldsWithValidation.vehicleYearModel = {
            ...this.fieldsWithValidation.vehicleYearModel,
            label: res.vehicle.year_model,
          };
          this.vehicleFipeCode = res.vehicle.fipe_code;
          this.vehicleColor = res.vehicle.color;
          this.vehiclePorts = res.vehicle.ports;
          this.vehicleEngineNumber = res.vehicle.engine_number;
          this.vehicleRenavam = res.vehicle.renavam;
          this.vehicleCylinderCapacity = res.vehicle.cylinder_capacity;
          this.vehicleFuel = res.vehicle.fuel;
          this.vehiclePassengerQuantity = res.vehicle.passenger_quantity;
          this.fieldsWithValidation.fipeResult = res.vehicle.fipe_result;
          this.vehicleResult = res.vehicle.plate_result;
          this.invoiceDocument = res.vehicle.invoice_document;

          if (res.vehicle.plate_result) {
            this.selectedFipeModel = res.vehicle.plate_result.fipe_data.find(
              (fipe) => fipe.fipe_code === res.vehicle.fipe_result.fipe_code,
            );
          }

          this.increases = res.all_increases.increases;
          this.zipCodeIncreases = res.all_increases.zipCodeIncreases;

          for (let increase of res.increases_answers) {
            const increaseComplete = this.increases.find(
              (inc) => inc.id === increase.id,
            );

            const response = increaseComplete.answers.find(
              (res) => res.id === increase.answers,
            );

            this.$set(
              this.fieldsWithValidation.increasesAnswers,
              increase.id,
              response,
            );
          }

          this.quoatiotionGenerated = true;
          this.prize = res.prize;

          this.products = res.all_coverages.details;
          if (res.coverage_contracted.length > 0) {
            this.selectedProducts = [...res.coverage_contracted];
          } else {
            this.setDefaultSelectedProducts();
          }

          res.charges.map((charge) => {
            this.form.carregamentos[charge.label] = {
              idCarregamento: charge.id,
              label: charge.label,
              porcentagem: charge.percentage,
              createdAt: charge.createdAt,
              updatedAt: charge.updatedAt,
              deletedAt: charge.deletedAt,
            };
          });

          this.form.desconto = res.prize.discount;

          if (!this.brokers.length) {
            this.brokers = [
              {
                id: this.quotation.broker.id,
                label: this.quotation.broker.name,
              },
            ];
          }

          this.calculate();
          this.disablePlate = this.fieldsWithValidation.vehiclePlate != '';
          this.disableChassis = !!this.fieldsWithValidation.vehicleChassis;
          this.$vs.loading.close();
          this.addDealershipExitDateValidation();
          this.addMin30DaysValidation();
        })
        .catch(() => {
          this.$router.push({ name: 'pageError404' });
          this.$vs.loading.close();
        })
        .finally(() => {
          this.getCongeners(this.fieldsWithValidation.insuranceCompanyCode);
        });
    },
    addDealershipExitDateValidation() {
      Validator.extend('require_invoice_date', {
        getMessage: () =>
          `É necessário preencher a data de emissão da nota fiscal.`,
        validate: () => Boolean(this.fieldsWithValidation.vehicleInvoiceDate),
      });
      Validator.extend('after_invoice_date', {
        getMessage: (field) =>
          `${field} não deve ser anterior a data de emissão da nota fiscal.`,
        validate: (value) => {
          if (!this.fieldsWithValidation.vehicleInvoiceDate) {
            return false;
          }
          let [day, month, year] = value.split('/');
          const dealershipExitDate = new Date(year, month - 1, day, 0, 0, 0);
          [day, month, year] =
            this.fieldsWithValidation.vehicleInvoiceDate.split('/');
          const invoiceDate = new Date(year, month - 1, day, 0, 0, 0);

          return dealershipExitDate >= invoiceDate;
        },
      });
    },
    addMin30DaysValidation() {
      Validator.extend('min_30days', {
        getMessage: () => `Não deve ser inferior a 30 dias.`,
        validate: (value) => {
          if (this.isAlreadyTransmittedOrCanceled) {
            return true;
          }
          let [day, month, year] = value.split('/');
          let dateNf = new Date(year, month - 1, day, 0, 0, 0);
          let today = new Date();
          today.setHours(0, 0, 0, 0);

          let minDate = new Date(today);
          minDate.setDate(minDate.getDate() - 30);

          return dateNf >= minDate;
        },
      });
    },
    getCpfData() {
      this.$vs.loading();

      autoApi
        .getCpfData(this.fieldsWithValidation.cpfcnpj)
        .then((res) => {
          this.fieldsWithValidation.gender = res.gender;
          this.fieldsWithValidation.name = res.name;
          this.fieldsWithValidation.birthDate = dateConversion.convertISOToDate(
            res.birthdate,
          );

          if (this.insuredIsMainDriver) {
            this.fieldsWithValidation.driverName = res.name;
            this.fieldsWithValidation.driverGender = res.gender;
            this.fieldsWithValidation.driverBirthdate =
              dateConversion.convertISOToDate(res.birthdate);
          }

          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    getCharges() {
      autoApi
        .getCharges()
        .then((res) => {
          res.map((charge) => {
            this.form.carregamentos[charge.label] = {
              idCarregamento: charge.id,
              label: charge.label,
              porcentagem: charge.default,
              createdAt: charge.createdAt,
              updatedAt: charge.updatedAt,
              deletedAt: charge.deletedAt,
            };
          });
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao buscar os carregamentos');
        });
    },
    getVehicleTypes() {
      autoApi
        .getVehicleTypes()
        .then((res) => {
          this.vehicleTypes = res;
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao buscar os tipos de veículos');
        });
    },
    getIncreases() {
      if (!this.fieldsWithValidation.overnightZipCode) return;

      autoApi
        .getIncreases(this.fieldsWithValidation.overnightZipCode)
        .then((res) => {
          this.increases = res.increases;
          this.zipCodeIncreases = res.zipCodeIncreases;
          this.calculate();
        })
        .catch(() => {
          notify.notifyFail(this.$vs, 'Erro ao buscar as coberturas');
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });

        this[array].sort(function (a, b) {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
        this[array].unshift({ id: null, label: 'Selecione' });
      });
    },
    keymonitor: function () {
      if (this.fieldsWithValidation.overnightZipCode.length == 10) {
        this.$vs.loading();

        this.getIncreases();

        var cepbusca = this.fieldsWithValidation.overnightZipCode
          .replace('.', '')
          .replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            this.overnightCepApiResult = !!res.data;
            this.fieldsWithValidation.overnightStreet = res.data.street;
            this.overnightNeighborhood = res.data.neighborhood;
            this.fieldsWithValidation.overnightCity = res.data.city;
            this.fieldsWithValidation.overnightState = res.data.state;

            this.$vs.loading.close();
          })
          .catch(() => {
            this.overnightCepApiResult = false;
            this.fieldsWithValidation.overnightStreet = null;
            this.overnightNeighborhood = null;
            this.fieldsWithValidation.overnightCity = null;
            this.fieldsWithValidation.overnightState = null;
            this.$vs.loading.close();
            notify.notifyFail(this.$vs, 'Não foi possível encontrar o cep');
          });
      }
    },
    zipCodeInsured: function () {
      if (
        this.fieldsWithValidation.address.zipCode &&
        this.fieldsWithValidation.address.zipCode.length == 10
      ) {
        this.$vs.loading();

        this.getIncreases();

        var cepbusca = this.fieldsWithValidation.address.zipCode
          .replace('.', '')
          .replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            this.fieldsWithValidation.address.cepApiResult = !!res.data;
            this.fieldsWithValidation.address.street = res.data.street;
            this.fieldsWithValidation.address.neighborhood =
              res.data.neighborhood;
            this.fieldsWithValidation.address.city = res.data.city;
            this.fieldsWithValidation.address.state = res.data.state;

            this.hasCepApiReturnedStreet =
              this.fieldsWithValidation.address.street != '';
            this.hasCepApiReturnedNeighborhood =
              this.fieldsWithValidation.address.neighborhood != '';
            this.hasCepApiReturnedState =
              this.fieldsWithValidation.address.state != '';
            this.hasCepApiReturnedCity =
              this.fieldsWithValidation.address.city != '';

            this.$vs.loading.close();
          })
          .catch(() => {
            this.fieldsWithValidation.address.cepApiResult = false;
            this.fieldsWithValidation.address.street = null;
            this.fieldsWithValidation.address.neighborhood = null;
            this.fieldsWithValidation.address.city = null;
            this.fieldsWithValidation.address.state = null;
            this.$vs.loading.close();
            notify.notifyFail(this.$vs, 'Não foi possível encontrar o cep');
          });
      }
    },
    getCityDataInsured(model, array, campoDescricao, campoPK) {
      if (!this.fieldsWithValidation.address.state) {
        this[array] = [];
        this.fieldsWithValidation.address.city = null;
        return;
      }

      this[array] = [];
      if (
        this.fieldsWithValidation.address.state &&
        this.fieldsWithValidation.address.state.id
      ) {
        this.$vs.loading();

        service
          .getAll(
            'g',
            {},
            `${model}/list/codUf/${this.fieldsWithValidation.address.state.id}`,
          )
          .then((res) => {
            if (res)
              res.data.forEach((element) => {
                this[array].push({
                  id: element[campoPK],
                  label: element[campoDescricao],
                });
              });

            this.$vs.loading.close();
          });
      }
    },
    selectStateInsured() {
      if (!this.fieldsWithValidation.address.state) {
        this.fieldsWithValidation.address.city = null;
        return;
      }

      const aux = this.estados.find(
        (x) => x.id === this.fieldsWithValidation.address.state.id,
      );
      this.fieldsWithValidation.address.state = aux.label;
    },
    selectCityInsured() {
      if (!this.fieldsWithValidation.address.city) {
        this.fieldsWithValidation.address.city = null;
        return;
      }

      var aux = this.cidades.find(
        (x) => x.id === this.fieldsWithValidation.address.city.id,
      );
      this.fieldsWithValidation.address.city = aux.label;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].touched ||
          this.veeFields[ref].dirty ||
          this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return false;
    },
    validateField(ref) {
      if (!this.$validator.fields.find({ name: ref })) {
        this.$validator.attach(ref, this.$validator.rules);
      }
      this.$validator.validate(ref);
    },
    validateClass(ref) {
      const field = this.$validator.fields.find({ name: ref });
      if (field && (field.dirty || field.validated)) {
        return this.errors.has(ref);
      }
      return false;
    },
    converteParams() {
      if (this.$route.query.hideLogo) {
        this.hideLogo = JSON.parse(this.$route.query.hideLogo.toLowerCase());
      } else this.hideLogo = false;

      if (this.$route.query.showPanel) {
        this.showPanel = JSON.parse(this.$route.query.showPanel.toLowerCase());
      } else this.showPanel = true;

      if (this.$route.query.fixedButton) {
        this.fixedButton = JSON.parse(
          this.$route.query.fixedButton.toLowerCase(),
        );
      } else this.fixedButton = false;

      if (this.$route.query.isRedirect) {
        this.isRedirect = JSON.parse(
          this.$route.query.isRedirect.toLowerCase(),
        );
      } else this.isRedirect = true;
    },
    openModalLogs() {
      this.modalLogs = true;
    },
    closeModalLogs() {
      this.modalLogs = false;
    },
    cancelChanges() {
      window.location.href = '/Cotacoes';
    },
    mostrarBotaoRecusa() {
      if (!this.quotation) {
        return false;
      }

      const statusPermitidos =
        this.quotation.status_id !== STATUS_PROPOSTA.COTACAO_CANCELADA.id &&
        this.quotation.status_id !== STATUS_PROPOSTA.COTACAO_RECUSADA.id &&
        this.quotation.status_id !== STATUS_PROPOSTA.RECUSADA.id &&
        this.quotation.status_id !== STATUS_PROPOSTA.FINALIZADO.id &&
        this.quotation.status_id !== STATUS_PROPOSTA.AGUARDANDO_ESTORNO.id &&
        this.quotation.status_id !== STATUS_PROPOSTA.ESTORNADA.id;

      if (!this.quotation.proposal_date) {
        return statusPermitidos;
      }

      const proposalDate = new Date(this.quotation.proposal_date);
      const hoje = new Date();

      const mesmoDia =
        proposalDate.getFullYear() === hoje.getFullYear() &&
        proposalDate.getMonth() === hoje.getMonth() &&
        proposalDate.getDate() === hoje.getDate();

      return statusPermitidos && mesmoDia;
    },
    recusarCorretora(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirmar`,
        text: 'Tem certeza que deseja cancelar esta cotação/proposta? Essa ação é irreversível.',
        acceptText: 'Confirmar',
        cancelText: 'Cancelar',
        accept: () => this.recusar(id),
      });
    },
    recusar(id) {
      const formRecusa = {
        idApolice: id,
        obsRecusa: null,
        idMotivoRecusa: ID_MOTIVO_RECUSA_CORRETORA_PADRAO,
      };

      const controller = 'auto';
      const action = 'refuse/' + formRecusa.idApolice;
      const data = {
        reasonId: formRecusa.idMotivoRecusa,
        description: formRecusa.obsRecusa,
      };

      this.$vs.loading();
      lifeService.update(controller, data, action).then(() => {
        this.$vs.loading.close();
        notify.notifySuccess(
          this.$vs,
          `${this.getLabelContrato()} cancelada com sucesso!`,
        );
      });
      this.getQuotation();
    },
    uploadDocument(folder, event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) {
        return;
      }

      this.files.set('file', event.target.files[0], event.target.files[0].name);

      const uploadPath = `${folder}/${this.quotation.id}`;

      this.$vs.loading();
      service
        .upload('Upload', uploadPath, this.files)
        .then((response) => {
          if (folder === 'apolice-bonus') {
            this.policyDocumentBonus = response;
          }
          if (folder === 'vehicle-invoice') {
            this.invoiceDocument = response;
          }

          this.$vs.loading.close();
        })
        .catch(function (e) {
          notify.notifyFail(this.$vs, e);
          this.$vs.loading.close();
        });
    },
    chooseFiles(inputId) {
      document.getElementById(inputId).click();
    },
    openEditionCellphoneAfterTransmited() {
      this.editionCellphoneAfterTransmited = true;
    },
    openEditionEmailAfterTransmited() {
      this.editionEmailAfterTransmited = true;
    },
    getCongeners(susep_code) {
      autoApi
        .getCongenersLabeled(susep_code)
        .then((res) => {
          res.forEach((congener) => {
            this.insuranceCompanies.push({
              id: congener.susep_code,
              label: congener.name,
            });
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async validateCi(value, resolve) {
      try {
        const response = await autoApi.getCiValidation(value);
        const isValid = response.isValid;

        this.$set(this.ciCache, value, isValid);

        resolve(isValid);
      } catch (error) {
        console.error('Erro ao validar CI:', error);
        notify.notifyFail(this.$vs, 'Erro ao validar CI');
        resolve(false);
      }
    },
    getZeroKMRule() {
      services
        .getAll('prior-inspections')
        .then((response) => {
          const zeroKMRule = response.data.find((item) => item.name === '0KM');
          if (zeroKMRule) {
            this.zeroKMRule = JSON.parse(zeroKMRule.registrations);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  async created() {
    Validator.extend('cpf_cnpj', {
      getMessage: (field) => `O campo ${field} deve ser um CPF ou CNPJ válido.`,
      validate: (value) => {
        return cpfcnpj.valida_cpf_cnpj(value);
      },
    });
    Validator.extend('min_age', {
      getMessage: () => `Você deve ter pelo menos 18 anos.`,
      validate: (value) => {
        let [day, month, year] = value.split('/');
        let birthDate = new Date(year, month - 1, day, 0, 0, 0);
        let today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age >= 18;
      },
    });
    Validator.extend('max_age', {
      getMessage: () => `Você deve ter pelo menos 100 anos.`,
      validate: (value) => {
        let [day, month, year] = value.split('/');
        let birthDate = new Date(year, month - 1, day, 0, 0, 0);
        let today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age <= 100;
      },
    });
    Validator.extend('less_than_today', {
      getMessage: () => `A data deve ser menor ou igual a hoje.`,
      validate: (value) => {
        let [day, month, year] = value.split('/');
        let dateNf = new Date(year, month - 1, day, 0, 0, 0);
        let today = new Date();
        return dateNf <= today;
      },
    });
    Validator.extend('br_phone', {
      getMessage: (field) =>
        `O campo ${field} deve ser um número de celular válido.`,
      validate: (value) => {
        const regex = /^(\+55)?\s?\(?\d{2}\)?\s?\d{5}-?\d{4}$/;
        return regex.test(value);
      },
    });
    Validator.extend('dddValidos', {
      getMessage: (field) => `O DDD ${field} não é valido,`,
      validate: (value) => {
        const ddd = value.substring(1, 3);
        const isValidDDD = DDD_BRASIL.includes(+ddd);
        return isValidDDD;
      },
    });
    Validator.extend('nome', {
      getMessage: (field) =>
        `O campo ${field} deve ser um ${
          field === 'CEP' ? field : 'Nome'
        } válido.`,
      validate: (value) => {
        return functions.nameValidate(value, this.isPerson);
      },
    });

    Validator.extend('is-person-name', {
      getMessage: (field) =>
        `O campo ${field} deve ser um ${
          field === 'CEP' ? field : 'Nome'
        } válido.`,
      validate: (value) => {
        return functions.nameValidate(value, true);
      },
    });

    this.debouncedCiValidation = debounce(this.validateCi, 500);

    Validator.extend('validate_ci', {
      getMessage: () => 'CI inválido',
      validate: (value) => {
        if (value.length !== 14) return true;

        return new Promise((resolve) => {
          if (this.ciCache[value] !== undefined) {
            resolve(this.ciCache[value]);
          } else {
            this.debouncedCiValidation(value, resolve);
          }
        });
      },
    });

    this.getBrokers();
    this.getDueDays();
    this.getPaymentMethods();
    this.getCharges();
    this.getVehicleTypes();
    this.getBrokerAccountConfigs();
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    this.converteParams();

    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.getQuotation();
    }
    this.getZeroKMRule();
  },
  mounted() {
    window.addEventListener('resize', this.updateWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth);
  },
  components: {
    ModalProposalHistory,
    ModalPriceChange,
    'v-select': vSelect,
    Money,
    flatPickr,
    CarregamentosForm,
    ModalHistoricoMensageria,
    ProductsList,
    FinancialSummary,
    TransmissionProposalLoading,
    Modal,
    ValidationObserver,
    ValidationProvider,
  },
};
</script>
<style lang="scss">
.form-landing {
  font-family: 'Roboto';
  padding-top: 60px;
  min-height: 80vh;

  .coluna-switch {
    padding: 0px 5px;

    div {
      background-color: #eff7ff;
      padding: 10px;
      min-height: 60px;
      vertical-align: middle;

      .label-switch {
        font-size: 12px;
        color: #078fcf;
      }
    }
  }

  label,
  .vs-input--label {
    color: #078fcf !important;
    font-size: 1rem;
  }

  .vs-input--input,
  .vs__dropdown-toggle,
  .vs-con-input .vs-inputx {
    height: 52px;
    background: white;
    border-radius: 9px;
    border: 1px #eeeeee solid !important;
  }
}

.botaoContratarAgora {
  background-color: #158c12;
  border-radius: 1rem;
  font-size: 1rem;
  color: #ffffff;
  padding: 1rem 2rem 1rem 2rem;
  transition: background-color 0.3s;
  font-family: 'Product Sans', sans-serif;
  cursor: pointer;
  border: 0;
  text-align: center;

  img {
    float: right;
    margin-top: 5px;
  }
}

.checkBoxNomeSocial {
  align-self: center;
}

#popup-historico-mensageria {
  .vs-popup {
    width: 1000px !important;
    height: auto;
  }

  .vs-popup--content {
    width: auto !important;
    padding: 1rem;
    font-size: 1rem;
  }
}
</style>
<style scoped>
.input-data {
  width: 300px !important;
  max-width: 100% !important;
}

body {
  background-color: white;
}

.vehicle-alert {
  background-color: rgba(var(--vs-primary), 0.15);
}

.con-slot-label {
  width: 100%;
  margin-left: 10px;
}

.semPadding {
  padding: 0em 0em 0em 0em !important;
}

.container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.my-custom-money {
  font-size: 1.5em;
  color: #555555;
}

.my-custom-money-danger {
  font-size: 1.5em;
  color: #ea5455;
}

.my-custom-input {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #b4b4b4;
  border-radius: 8px;
}

.my-custom-input-danger {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #ea5455;
  border-radius: 8px;
}

#meu-popup-personalizado.con-vs-popup .vs-popup {
  width: fit-content;
}
</style>
<style lang="scss" scoped>
.vs__search,
.vs__search:focus {
  padding: 0 6px !important;
}

.fixed-buttons {
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #ccc;
  padding: 10px;
  margin-left: -25px;
  background-color: #fff;
  z-index: 999;
}

.painel-no-border {
  box-shadow: none !important;
  padding-bottom: 70px;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 10px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.item-lista {
  border: 1px solid #ccc;
  padding: 15px;
}

.form-part-title {
  padding: 1em;
  background: #d8e2ff;

  span {
    color: #2b50bb;
    font-weight: 600;
  }
}

.input-data-ativacao {
  width: 100%;
}
</style>
<style lang="scss" scoped>
.title-item-veiculo {
  border-bottom: 1px solid #000;
}

.text-danger {
  font-size: 12px;
}

.no-padding-cols > .vs-col {
  padding: 0 !important;
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip {
  visibility: hidden;
  width: 200px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 4px;

  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;

  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-wrapper:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.purple-gradient-btn {
  background: #000000 !important;
  background-image: linear-gradient(
    30deg,
    rgba(135, 81, 252, 1),
    rgba(135, 81, 252, 0.5)
  ) !important;
}
</style>
